import { getAuthenticatedUserForQA } from './qaAuthentication';
import { Auth, Storage } from 'aws-amplify';
import * as XLSX from "xlsx";
import { getInstanceParameterFromManager } from "services/InstanceUtils";
import { PDFDocument } from 'pdf-lib';
import { Buffer } from "buffer";
import { v4 as uuid } from "uuid";
import { S3Client, HeadObjectCommand, ListObjectsV2Command } from '@aws-sdk/client-s3';
import { LambdaClient, InvokeCommand } from "@aws-sdk/client-lambda";
import { loadS3File, fetchMsg, logAudit, notifyUser, invokeLambdaWithRetry as invokeLambdaWithRetryBase, uint8Decode, invokeLambda, downloadS3Object, storageResultToBlob } from 'services/Helper';
import { loadSovAnalyseMetadata } from './sovAnalyseStatus';
import { withArchivedQaPayload } from './archivedQaPolicy';
import { renewArchivedQaSession, qaStoredValue, fetchArchivedQaSource } from './qaArchivedRequests';
import { saveQaWorkbookWithBridge } from './qaWorkbookRequests';
import { requestLargeQaSave, requestLargeQaSend } from './qaLargeRequests';
import { requestArchivedSovMetadata } from './qaSovMetadataRequests';
import { requestArchivedSovDownload } from './qaSovWorkbookRequests';
import { archivedSavedDocument } from './qaArchivedSaveResult';
export { renewArchivedQaSession, invokeArchivedQa } from './qaArchivedRequests';
export { archivedQaReadOnly } from './archivedQaPolicy';
const invokeLambdaWithRetry = (name, payload, ...options) => invokeLambdaWithRetryBase(name, withArchivedQaPayload(payload), ...options);
import { getParameterFromManager } from "../../../services/Utils";
import config from 'aws-exports';
import { invokeLambdaWithAPI } from 'services/Helper';
import { userTracer } from "../../../logging";
import { createUiLogger } from "../../../logging/uiLogger";
import {
    getS3PathExtension,
    isJsonS3Path,
    parseS3JsonText,
} from "./jsonContent";
import { getExtractedJsonDownloadName } from "newui/components/Utils/extractedFileName";
import { serializeQaDataForSave } from "./qaSaveSerialization";
import { countGenericQaFieldChanges } from "./genericFieldCounts";
const console = createUiLogger("meaplatform/classic/components/Utils/ExtractUtils.js");



const rulesCache = {};
export const ASYNC_PROGRESS_EVENT = "mea:async-progress";

function emitAsyncProgress(detail) {
    if (typeof window !== "undefined") {
        window.dispatchEvent(new CustomEvent(ASYNC_PROGRESS_EVENT, { detail }));
    }
}

function buildAsyncProgressPayload(baseDetail = {}, apiStatusJson = {}) {
    return {
        ...baseDetail,
        apiStatus: apiStatusJson?.apiStatus,
        taskBreakdown: apiStatusJson?.taskBreakdown,
        phaseHistory: apiStatusJson?.phaseHistory,
        resumedAt: apiStatusJson?.resumedAt,
        resumeCount: apiStatusJson?.resumeCount,
        chunkStats: apiStatusJson?.chunkStats,
        statePath: apiStatusJson?.statePath,
        isRunMacro: apiStatusJson?.isRunMacro,
        isMappedDataAsync: apiStatusJson?.isMappedDataAsync,
        mappedDataAction: apiStatusJson?.mappedDataAction
    };
}

function resolveMappedDataAsyncActionLabel(action, runMacro) {
    if (runMacro) {
        return "Macro";
    }
    const normalizedAction = `${action || ""}`.toLowerCase();
    if (normalizedAction === "copy_unmapped_columns") {
        return "Copy All Unmapped";
    }
    if (normalizedAction === "populatefixedvalues") {
        return "Populate Fixed Values";
    }
    return "Transformation";
}

function hasOrchestratedMappedDataProgress(apiStatusJson = {}) {
    return Boolean(apiStatusJson?.statePath)
        || (Array.isArray(apiStatusJson?.taskBreakdown) && apiStatusJson.taskBreakdown.length > 0)
        || Object.keys(apiStatusJson?.chunkStats || {}).length > 0
        || Number(apiStatusJson?.resumeCount || 0) > 0;
}

function getAsyncErrorMessage(apiPayload, fallbackMessage = "The request failed while processing in the background.") {
    return apiPayload?.response?.error
        || apiPayload?.response?.errorDescription
        || apiPayload?.error
        || apiPayload?.errorDescription
        || fallbackMessage;
}

export const getSpFolderPath = async (item) => {
    let spUrl = await getInstanceParameterFromManager("SHAREPOINT_ROOT_PATH");
    return decodeURIComponent(
        spUrl.sharePointURL.replace("{subid}", item.submissionIdentifier)
            .match(/\?.+/)[0]
            .match(/id=([^&]+)/)[1]
    ).match(/SubmissionDocuments.*/)[0];
}

export async function getDocDetails(document, showArchived) {
    try {
        const user = await Auth.currentAuthenticatedUser({
            bypassCache: true  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
        });
        var body = {
            "access_token": user.signInUserSession.idToken.jwtToken,
            "target": "fetchDocDetails",
            "document": document
        };
        if (showArchived) {
            body["showArchived"] = showArchived;
        }
        const init = {
            body: body
        };
        const resp = await invokeLambdaWithRetry("instanceHandler", init);
        return resp.response;
    } catch (err) {
        console.error('err: ', err);
        return false;
    }
}

export const fetchSubmissionDocumentlist = async (item) => {
    var fetchDocList = await getDocList(item);
    return fetchDocList;
}

export async function getDocList(document) {
    try {
        const user = await Auth.currentAuthenticatedUser({
            bypassCache: true  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
        });
        const body = {
            "access_token": user.signInUserSession.idToken.jwtToken,
            "target": "fetchDocList",
            "document": document
        };
        const init = {
            body: body
        };
        const data = await invokeLambdaWithRetry("instanceHandlerLarge", init);
        return data?.response;
    } catch (err) {
        console.error('err: ', err);
        return false;
    }
}

export async function fetchDeclineCodeList(mergedFileObj) {
    try {
        const user = await Auth.currentAuthenticatedUser({
            bypassCache: true  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
        });
        const body = {
            "access_token": user.signInUserSession.idToken.jwtToken,
            "target": "listTriageDeclinedReasons",
            "document": mergedFileObj
        };
        const init = {
            body: body
        };
        const data = await invokeLambdaWithRetry("instanceHandlerLarge", init);
        return data?.response;
    } catch (err) {
        console.error(err);
        return false;
    }
}

export async function updateEditedEntityExplanations(payload = {}) {
    try {
        const user = await Auth.currentAuthenticatedUser({
            bypassCache: true
        });
        const body = {
            access_token: user.signInUserSession.idToken.jwtToken,
            target: "updateExplanations",
            event: "updateExplanations",
            ...payload
        };
        const init = {
            body
        };
        const data = await invokeLambdaWithRetry("instanceHandler", init);
        return data?.response?.response || data?.response || data;
    } catch (err) {
        console.error("err: ", err);
        return false;
    }
}

export async function fetchExcelData(instanceExcelDetails) {
    const trace = userTracer.startOperation("s3.fetch-excel-sheets", {
        module: "extract-tool",
        screen: typeof window !== "undefined" ? window.location.pathname : "/",
        data: {
            filePath: instanceExcelDetails?.docPath,
            bucket: config.aws_user_files_s3_bucket,
            region: config.aws_project_region
        }
    });
    try {
        const excelS3DataRes = await Storage.get(instanceExcelDetails.docPath, { download: true });
        const buffer = await (await storageResultToBlob(excelS3DataRes)).arrayBuffer();
        const workbook = XLSX.read(buffer, { type: "array", bookSheets: true, bookProps: true });
        const sheets = getVisibleSheetNames(workbook);
        trace.finish({
            data: {
                filePath: instanceExcelDetails?.docPath,
                bucket: config.aws_user_files_s3_bucket,
                region: config.aws_project_region,
                found: true,
                sheetCount: sheets.length
            }
        });
        return sheets;
    } catch (error) {
        trace.fail(error, {
            data: {
                filePath: instanceExcelDetails?.docPath,
                bucket: config.aws_user_files_s3_bucket,
                region: config.aws_project_region
            }
        });
        throw error;
    }
}

function getVisibleSheetNames(workbook) {
    const workbookSheets = workbook?.Workbook?.Sheets;
    if (Array.isArray(workbookSheets) && workbookSheets.length > 0) {
        return workbookSheets.filter(i => !i.Hidden).map(i => i.name);
    }
    return Array.isArray(workbook?.SheetNames) ? workbook.SheetNames : [];
}

export function fetchSheets(buffer) {
    const workbook = XLSX.read(buffer, { type: "array", bookSheets: true, bookProps: true });
    let workbookSheets = workbook?.Workbook?.Sheets;
    if (!Array.isArray(workbookSheets) || workbookSheets.length === 0) {
        workbookSheets = XLSX.read(buffer, { type: "array" })?.Workbook?.Sheets;
    }
    if (Array.isArray(workbookSheets)) {
        return workbookSheets.filter(i => !i.Hidden).map(i => i.name);
    }
    return [];
}

export async function fetchExcelFromS3(filePath) {
    const trace = userTracer.startOperation("s3.fetch-binary", {
        module: "extract-tool",
        screen: typeof window !== "undefined" ? window.location.pathname : "/",
        data: {
            filePath,
            bucket: config.aws_user_files_s3_bucket,
            region: config.aws_project_region
        }
    });
    try {
        let response = await fetchFromS3(filePath);
        let byteArray = await (await storageResultToBlob(response)).arrayBuffer();
        trace.finish({
            data: {
                filePath,
                bucket: config.aws_user_files_s3_bucket,
                region: config.aws_project_region,
                found: true
            } 
        });
        return byteArray;
    } catch (error) {
        if (error?.name === "NoSuchKey" || error?.code === "NoSuchKey") {
            trace.finish({
                data: {
                    filePath,
                    bucket: config.aws_user_files_s3_bucket,
                    region: config.aws_project_region,
                    found: false
                }
            });
        } else {
            trace.fail(error, {
                data: {
                    filePath,
                    bucket: config.aws_user_files_s3_bucket,
                    region: config.aws_project_region
                }
            });
        }
        return false;
    }
}

const DOWNLOAD_PROGRESS_INTERVAL_MS = 250;

function emitDownloadProgress(onProgress, loadedBytes, totalBytes, force = false, progressState = {}) {
    if (typeof onProgress !== "function") {
        return;
    }
    const now = Date.now();
    if (!force && now - (progressState.lastReportedAt || 0) < DOWNLOAD_PROGRESS_INTERVAL_MS) {
        return;
    }
    progressState.lastReportedAt = now;
    try {
        onProgress({
            loadedBytes,
            totalBytes,
            percent: totalBytes > 0 ? Math.min(100, Math.round((loadedBytes / totalBytes) * 100)) : null
        });
    } catch {
        // Progress reporting is best-effort and must never block extraction.
    }
}

async function fetchTextWithDownloadProgress(filePath, onProgress) {
    const signedUrl = await Storage.get(filePath, {
        level: "public",
        bucket: config.aws_user_files_s3_bucket,
        region: config.aws_project_region,
        download: false,
        expires: 300,
        cacheControl: "no-cache"
    });
    const response = await fetch(signedUrl, { cache: "no-store" });
    if (!response.ok) {
        throw new Error(`S3 download failed with HTTP ${response.status}`);
    }

    const totalBytes = Number(response.headers.get("content-length")) || 0;
    if (!response.body || typeof response.body.getReader !== "function") {
        const text = await response.text();
        const loadedBytes = new Blob([text]).size;
        emitDownloadProgress(onProgress, loadedBytes, totalBytes || loadedBytes, true);
        return text;
    }

    const reader = response.body.getReader();
    const chunks = [];
    const progressState = {};
    let loadedBytes = 0;
    while (true) {
        const { done, value } = await reader.read();
        if (done) {
            break;
        }
        chunks.push(value);
        loadedBytes += value.byteLength;
        emitDownloadProgress(onProgress, loadedBytes, totalBytes, false, progressState);
    }
    emitDownloadProgress(onProgress, loadedBytes, totalBytes || loadedBytes, true, progressState);
    return new Blob(chunks).text();
}

const EXTRACTED_WORKBOOK_MANIFEST_FORMAT = "mea.extractedWorkbookManifest";
const EXTRACTED_WORKBOOK_PREVIEW_ROW_LIMIT = 1000;

function isExtractedWorkbookManifest(value) {
    return value?.format === EXTRACTED_WORKBOOK_MANIFEST_FORMAT && value?.storageMode === "chunked" && Array.isArray(value?.sheets);
}

function getPositiveInteger(value, fallback) {
    const parsed = Number(value);
    return Number.isFinite(parsed) && parsed > 0 ? Math.floor(parsed) : fallback;
}

function resolveExtractedWorkbookPreviewRowLimit(manifest, options = {}) {
    return getPositiveInteger(
        options?.maxRowsPerSheet
        ?? manifest?.chunking?.previewRowsPerSheet
        ?? manifest?.chunking?.previewRowLimit,
        EXTRACTED_WORKBOOK_PREVIEW_ROW_LIMIT
    );
}

function appendRowsWithinPreviewLimit(sheet, rows, maxRowsPerSheet) {
    const remainingRows = maxRowsPerSheet - sheet.length;
    if (remainingRows <= 0) {
        return;
    }
    sheet.push(...rows.slice(0, remainingRows));
}

async function hydrateExtractedWorkbookManifest(manifest, options = {}) {
    const workbook = [];
    const maxRowsPerSheet = resolveExtractedWorkbookPreviewRowLimit(manifest, options);
    for (const sheetInfo of manifest.sheets) {
        const sheet = [];
        const chunks = Array.isArray(sheetInfo?.chunks) ? sheetInfo.chunks : [];
        for (const chunk of chunks) {
            if (!chunk?.path || sheet.length >= maxRowsPerSheet) continue;
            const chunkRows = await fetchJSONFromS3(chunk.path);
            if (!Array.isArray(chunkRows)) continue;
            const rowsToAppend = sheet.length > 0 && sheetInfo?.headerIncludedInEachChunk === true && chunkRows.length > 0
                ? chunkRows.slice(1)
                : chunkRows;
            appendRowsWithinPreviewLimit(sheet, rowsToAppend, maxRowsPerSheet);
        }
        workbook[sheetInfo?.sheetIndex ?? workbook.length] = sheet;
    }
    Object.defineProperty(workbook, "__extractedWorkbookPreview", {
        value: {
            storageMode: "chunked",
            previewRowsPerSheet: maxRowsPerSheet,
            totalRows: manifest?.stats?.totalRows,
            sheets: manifest.sheets.map((sheet, index) => {
                const sheetIndex = sheet?.sheetIndex ?? index;
                return {
                    sheetIndex,
                    sheetName: sheet?.sheetName,
                    totalRows: sheet?.totalRows,
                    loadedRows: workbook[sheetIndex]?.length ?? 0
                };
            })
        },
        enumerable: false
    });
    return workbook;
}

export async function fetchJSONFromS3(filePath, instanceRegion, instanceBucket, returnStringifyJSON, options = {}) {
    const trace = userTracer.startOperation("s3.fetch-json", {
        module: "extract-tool",
        screen: typeof window !== "undefined" ? window.location.pathname : "/",
        data: {
            filePath,
            bucket: config.aws_user_files_s3_bucket,
            region: config.aws_project_region
        }
    });
    try {
        let jsonData;
        if (typeof options?.onProgress === "function") {
            try {
                jsonData = await fetchTextWithDownloadProgress(filePath, options.onProgress);
            } catch {
                try {
                    options.onProgress({
                        loadedBytes: 0,
                        totalBytes: 0,
                        percent: null,
                        isFallback: true
                    });
                } catch {
                    // Progress reporting is best-effort and must never block extraction.
                }
                let response = await fetchFromS3(filePath);
                jsonData = await (await storageResultToBlob(response)).text();
                const loadedBytes = new Blob([jsonData]).size;
                emitDownloadProgress(options.onProgress, loadedBytes, loadedBytes, true);
            }
        } else {
            let response = await fetchFromS3(filePath);
            jsonData = await (await storageResultToBlob(response)).text();
        }
        const parsed = JSON.parse(jsonData);
        const resolved = isExtractedWorkbookManifest(parsed) ? await hydrateExtractedWorkbookManifest(parsed) : parsed;
        trace.finish({
            data: {
                filePath,
                bucket: config.aws_user_files_s3_bucket,
                region: config.aws_project_region,
                found: true
            }
        });
        return returnStringifyJSON ? JSON.stringify(resolved) : resolved;
    } catch (error) {
        if (error?.name === "NoSuchKey" || error?.code === "NoSuchKey") {
            trace.finish({
                data: {
                    filePath,
                    bucket: config.aws_user_files_s3_bucket,
                    region: config.aws_project_region,
                    found: false
                }
            });
        } else {
            trace.fail(error, {
                data: {
                    filePath,
                    bucket: config.aws_user_files_s3_bucket,
                    region: config.aws_project_region
                }
            });
        }
        return false;
    }
}

export async function fetchJsonData(details) {
    const trace = userTracer.startOperation("s3.fetch-json-text", {
        module: "extract-tool",
        screen: typeof window !== "undefined" ? window.location.pathname : "/",
        data: {
            filePath: details?.docPath,
            bucket: config.aws_user_files_s3_bucket,
            region: config.aws_project_region
        }
    });
    try {
        if (!isJsonS3Path(details?.docPath)) {
            const error = new Error("JSON fetch rejected a non-JSON object path.");
            error.code = "non_json_path";
            throw error;
        }
        const jsonS3DataRes = await Storage.get(details.docPath, { download: true });
        const jsonData = await (await storageResultToBlob(jsonS3DataRes)).text();
        const parsedJsonData = parseS3JsonText(jsonData);
        const resolvedJsonData = isExtractedWorkbookManifest(parsedJsonData)
            ? JSON.stringify(await hydrateExtractedWorkbookManifest(parsedJsonData))
            : jsonData.replace(/^\uFEFF/, "");
        trace.finish({
            data: {
                filePath: details?.docPath,
                bucket: config.aws_user_files_s3_bucket,
                region: config.aws_project_region,
                found: true
            }
        });
        return resolvedJsonData;
    } catch (error) {
        if (error?.name === "NoSuchKey" || error?.code === "NoSuchKey") {
            trace.finish({
                data: {
                    filePath: details?.docPath,
                    bucket: config.aws_user_files_s3_bucket,
                    region: config.aws_project_region,
                    found: false
                }
            });
        } else {
            console.warn("fetchJsonData failed safely", {
                pathExtension: getS3PathExtension(details?.docPath),
                contentKind: error?.code || "json_fetch_error"
            });
            trace.fail(error, {
                data: {
                    filePath: details?.docPath,
                    bucket: config.aws_user_files_s3_bucket,
                    region: config.aws_project_region,
                    contentKind: error?.code || "json_fetch_error"
                }
            });
        }
        return false;
    }
}

export async function fetchFromS3(filePath) {
    const trace = userTracer.startOperation("s3.get-object", {
        module: "extract-tool",
        screen: typeof window !== "undefined" ? window.location.pathname : "/",
        data: {
            filePath,
            bucket: config.aws_user_files_s3_bucket,
            region: config.aws_project_region
        }
    });
    try {
        let resp = await Storage.get(filePath, {
            level: 'public',
            bucket: config.aws_user_files_s3_bucket,
            region: config.aws_project_region,
            download: true,
            cacheControl: "no-cache"
        });
        trace.finish({
            data: {
                filePath,
                bucket: config.aws_user_files_s3_bucket,
                region: config.aws_project_region,
                found: true
            }
        });
        return resp;
    } catch (error) {
        if (error?.name === "NoSuchKey" || error?.code === "NoSuchKey") {
            trace.finish({
                data: {
                    filePath,
                    bucket: config.aws_user_files_s3_bucket,
                    region: config.aws_project_region,
                    found: false
                }
            });
        } else {
            trace.fail(error, {
                data: {
                    filePath,
                    bucket: config.aws_user_files_s3_bucket,
                    region: config.aws_project_region
                }
            });
        }
        throw error;
    }
}

export async function updateToS3(filePath, body) {
    const trace = userTracer.startOperation("s3.put-object", {
        module: "extract-tool",
        screen: typeof window !== "undefined" ? window.location.pathname : "/",
        data: {
            filePath,
            bucket: config.aws_user_files_s3_bucket,
            region: config.aws_project_region
        }
    });
    try {
        const result = await Storage.put(filePath, body, {
            level: 'public',
            bucket: config.aws_user_files_s3_bucket,
            region: config.aws_project_region
        });
        trace.finish({
            data: {
                filePath,
                bucket: config.aws_user_files_s3_bucket,
                region: config.aws_project_region
            }
        });
        return result;
    } catch (error) {
        trace.fail(error, {
            data: {
                filePath,
                bucket: config.aws_user_files_s3_bucket,
                region: config.aws_project_region
            }
        });
        throw error;
    }
}

export async function deleteFromS3(filePath) {
    try {
        if (!filePath) {
            return false;
        }
        const trace = userTracer.startOperation("s3.delete-object", {
            module: "extract-tool",
            screen: typeof window !== "undefined" ? window.location.pathname : "/",
            data: {
                filePath,
                bucket: config.aws_user_files_s3_bucket,
                region: config.aws_project_region
            }
        });
        try {
            await Storage.remove(filePath, {
                level: 'public',
                bucket: config.aws_user_files_s3_bucket,
                region: config.aws_project_region
            });
            trace.finish({
                data: {
                    filePath,
                    bucket: config.aws_user_files_s3_bucket,
                    region: config.aws_project_region
                }
            });
        } catch (error) {
            trace.fail(error, {
                data: {
                    filePath,
                    bucket: config.aws_user_files_s3_bucket,
                    region: config.aws_project_region
                }
            });
            throw error;
        }
        return true;
    } catch (err) {
        console.debug("err: ", err);
        return false;
    }
}

export async function getStorageData(instanceDetails) {
    try {
        const user = await Auth.currentAuthenticatedUser({
            bypassCache: true, // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
        });
        const body = {
            access_token: user.signInUserSession.idToken.jwtToken,
            target: "fetchStorageDetails",
            document: instanceDetails,
        };
        const init = {
            body: body,
        };
        // if (data !== undefined) {
        //     return JSON.parse(uint8Decode(data.Payload)).response;
        // }
        const data = await invokeLambdaWithRetry("instanceHandler", init);
        return data?.response;
    } catch (err) {
        console.error("err: ", err);
        return false;
    }
}

export async function getPdfPageNumber(pdfObj) {
    try {
        const s3Out = await Storage.get(pdfObj.documentFullPath.replace(/(\.[^.]+)$/i, (match, extension) => extension.toLowerCase() === '.pdf' ? extension : '.pdf'), { download: true });
        const pdfContent = await (await storageResultToBlob(s3Out)).arrayBuffer(); // Convert the Blob to ArrayBuffer
        const pdfDoc = await PDFDocument.load(pdfContent, { ignoreEncryption: true });
        const numberOfPages = pdfDoc.getPages().length;
        return { numberOfPages };
    } catch (error) {
        console.error("Pdf images only we have page number");
    }
}

export async function getPdfImageOfPageNumber(pdfObj) {
    let numberOfPages;
    if (pdfObj.totalPdfPageCount <= import.meta.env.VITE_NUMBER_OF_PAGES) {
        numberOfPages = pdfObj.totalPdfPageCount;
    } else if (pdfObj.totalPdfPageCount > import.meta.env.VITE_NUMBER_OF_PAGES && pdfObj.pageIndex >= import.meta.env.VITE_NUMBER_OF_PAGES) {
        numberOfPages = Math.min(parseInt(pdfObj.totalPdfPageCount) - parseInt(pdfObj.pageIndex) + 1, parseInt(import.meta.env.VITE_NUMBER_OF_PAGES));
    } else {
        numberOfPages = import.meta.env.VITE_NUMBER_OF_PAGES;
    }
    var exists = await doesFileExist(`${pdfObj.documentFullPath.replace(/\.(pdf?|docx?|ppt?|pptx?|doc?|jpg?|jpeg?|png?)$/i, '_images')}/page${pdfObj.pageIndex}.jpeg`);
    if (exists === false) {
        await generateImageForPdf(pdfObj.documentFullPath, pdfObj.pageIndex, numberOfPages);
    }
    let URLs = [];
    let lastPage = Math.min(parseInt(pdfObj.pageIndex) + parseInt(import.meta.env.VITE_NUMBER_OF_PAGES), (parseInt(pdfObj.totalPdfPageCount) + 1));
    for (let i = pdfObj.pageIndex; i < lastPage; i++) {
        const url = await getSignedUrl(`${pdfObj.documentFullPath.replace(/\.(pdf?|docx?|ppt?|pptx?|doc?|jpg?|jpeg?|png?)$/i, '_images')}/page${i}.jpeg`, "getObject", `page${i}.jpeg`);
        URLs.push({ [i]: url });
    }
    let resp = URLs;
    return resp;
}

export async function doesFileExist(s3Path) {
    try {
        const params = {
            Bucket: config.aws_user_files_s3_bucket,
            Key: `public/${s3Path}`
        };
        const credentials = await Auth.currentCredentials();
        const s3 = new S3Client({
            region: config.aws_project_region,
            credentials: credentials
        });
        await s3.send(new HeadObjectCommand(params));
        return true;
    } catch (error) {
        console.debug(`${s3Path} NotFound`);
        return false;
    }
}

export async function generateImageForPdf(documentFullPath, pageIndex) {
    try {
        const backend = config.aws_user_files_s3_bucket.split('-');
        const user = await Auth.currentAuthenticatedUser({
            bypassCache: true, // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
        });
        const body = {
            access_token: user.signInUserSession.idToken.jwtToken,
            target: "generateImageforPdf",
            documentFullPath: documentFullPath,
            pageIndex: pageIndex,
        };
        const init = {
            body: JSON.stringify(body),
        };

        let result = await invokeLambdaWithRetry("instanceHandler", init);
        return result.response;
    } catch (err) {
        console.error("err: ", err);
        return false;
    }
}

export const getSignedUrl = async (filePath) => {
    const url = await Storage.get(filePath);
    return url;
}

export async function getFilePath(submissionIdentifier, fileName, archivedQa) {
    try {
        const user = await Auth.currentAuthenticatedUser({
            bypassCache: true, // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
        });
        const body = {
            access_token: user.signInUserSession.idToken.jwtToken,
            target: "getFilePath",
            ...(archivedQa ? { archivedQa } : {}),
            submissionIdentifier: submissionIdentifier,
            fileName: fileName,
        };
        const init = {
            body: body,
        };
        const data = await invokeLambdaWithRetry("instanceHandler", init);
        return data?.response
    } catch (err) {
        console.error(err);
        return false;
    }
}

export async function uploadToS3AndUpdateDocumentTable(payload) {
    try {
        const init = {
            body: payload,
        };
        const data = await invokeLambdaWithRetry("instanceHandler", init);
        return data?.response
    } catch (err) {
        console.error("err: ", err);
        return false;
    }
}

export async function mergeLargeGridPreviewEdits(payload) {
    try {
        const user = await Auth.currentAuthenticatedUser({
            bypassCache: true
        });
        const init = {
            body: {
                ...payload,
                access_token: user.signInUserSession.idToken.jwtToken,
                target: "mergeLargeGridPreviewEdits"
            },
        };
        const data = await invokeLambdaWithRetry("instanceHandler", init);
        return data?.response;
    } catch (err) {
        console.error("err: ", err);
        return false;
    }
}

export async function fetchLargeGridPreviewWindow(payload) {
    try {
        const user = await Auth.currentAuthenticatedUser({
            bypassCache: true
        });
        const init = {
            body: {
                ...payload,
                access_token: user.signInUserSession.idToken.jwtToken,
                target: "fetchLargeGridPreviewWindow"
            },
        };
        const data = await invokeLambdaWithRetry("instanceHandler", init);
        return data?.response;
    } catch (err) {
        console.error("err: ", err);
        return false;
    }
}

export const invokeInstanceDispatcher = async (document, status, rejectionReasons, uploadDocument, triageLane, declineCode, runValidation, selectedDateFormat) => {
    try {
        const finishRequestStartedAt = Date.now();
        const user = await Auth.currentAuthenticatedUser({
            bypassCache: true  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
        });
        const body = {
            "access_token": user.signInUserSession.idToken.jwtToken,
            "target": "finish",
            "document": document,
            "status": status,
            "rejectionReasons": rejectionReasons,
            "uploadDocument": uploadDocument,
            "triageLane": triageLane,
            "declineCode": declineCode,
            "runValidation": runValidation,
            ...(selectedDateFormat && selectedDateFormat?.length > 0 ? { inputDateFormat: selectedDateFormat } : {})
        };
        const init = {
            body: body
        };
        let resp = await invokeLambdaWithRetry("instanceHandler", init);
        const invokeTypeForTarget = await fetchInvokeType(body?.target);
        const initialApiStatus = resp?.response?.apiStatus || resp?.apiStatus || resp?.status;
        const pendingFinishStatuses = ["pending", "queued", "running", "retrying"];
        const shouldPollFinish =
            invokeTypeForTarget?.toLowerCase() === "api" ||
            pendingFinishStatuses.includes(initialApiStatus?.toString()?.trim()?.toLowerCase());
        if (shouldPollFinish) {
            const apiStatusJson = await fetchApiStatusJSON(document.submissionIdentifier, document.document_id, "finish");
            const currentApiStatus = apiStatusJson?.apiStatus?.toString()?.trim()?.toLowerCase();
            const statusUpdatedAt = apiStatusJson?.progress?.updatedAt
                ? Date.parse(apiStatusJson.progress.updatedAt)
                : NaN;
            const isFreshFinishStatus = Number.isFinite(statusUpdatedAt)
                && statusUpdatedAt >= (finishRequestStartedAt - 1000);
            if (!currentApiStatus || pendingFinishStatuses.includes(currentApiStatus) || !isFreshFinishStatus) {
                const apiData = await pollApiStatus(
                    document.templateName,
                    document.submissionIdentifier,
                    document.document_id,
                    "finish",
                    undefined,
                    undefined,
                    finishRequestStartedAt
                );
                if (apiData.status && apiData.status !== "stopped") {
                    resp = apiData;
                }
            }
        }
        return resp;
    } catch (err) {
        console.error('err: ', err);
        return false;
    }
}

export async function invokeImageWithBoundingBox(imageDetails, documentObj, ocrMethod) {
    try {
        const user = await Auth.currentAuthenticatedUser({
            bypassCache: true, // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
        });
        const body = {
            access_token: user.signInUserSession.idToken.jwtToken,
            target: "readPdfText",
            ...imageDetails,
            document: documentObj,
            ocrMethod: ocrMethod
        };
        const init = {
            body: JSON.stringify(body),
        };

        let result = await invokeLambdaWithRetry("instanceHandler", init);
        return result === false ? false : result.response.body;
    } catch (err) {
        console.error("err: ", err);
        return false;
    }
}

export async function extractFromTesseract(dataUrl, boundingId, submissionId) {
    try {
        const user = await Auth.currentAuthenticatedUser({
            bypassCache: true, // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
        });
        const uniqueId = user.username + boundingId;
        const documentPath = submissionId + "/" + uniqueId + ".jpeg";
        const file = Buffer.from(dataUrl.split(',')[1], 'base64');
        await Storage.put(documentPath, file, {
            contentType: 'image/jpeg', // Set the content type based on your image format
        });
        const body = {
            access_token: user.signInUserSession.idToken.jwtToken,
            target: "extractFromTesseract",
            documentPath
        };
        const init = {
            body: body,
        };
        const data = await invokeLambdaWithRetry("instanceHandler", init);
        // if (data && data.Payload === false) {
        //     return false;
        // }
        return data === false ? false : data?.response;
    } catch (err) {
        console.error("err: ", err);
        return false;
    }
}

export async function getDataFromS3Folder(path) {
    try {
        const credentials = await Auth.currentCredentials();
        const s3 = new S3Client({
            region: config.aws_project_region,
            credentials: credentials
        });
        const params = { Bucket: config.aws_user_files_s3_bucket, Prefix: path };
        const resp = await s3.send(new ListObjectsV2Command(params));
        return resp;
    } catch (err) {
        console.error("err: ", err);
        return false;
    }
}

export async function getParameterData(paramsName) {
    return await getInstanceParameterFromManager(paramsName);
}

//Send QA Data starts
export async function loadScratchPad(jsonPath, options = {}) {
    try {
        const jsonS3DataRes = await Storage.get(jsonPath, { download: true });
        return storageResultToBlob(jsonS3DataRes).then(blob => blob.text()).then(json_data => {
            var data = JSON.parse(json_data);
            return data;
        });
    } catch (error) {
        const errorCode = error?.code || error?.name;
        const isMissing = errorCode === "NoSuchKey" || errorCode === "NotFound";
        if (options.throwOnError === true && !isMissing) throw error;
        return false;
    }
}

export async function saveQAFile(fullPath, jsonFilePath, sheetNames, document = {}, inputFileType) {
    return saveQaWorkbookWithBridge(fullPath, jsonFilePath, sheetNames, document, inputFileType, {
        authenticate: options => Auth.currentAuthenticatedUser(options), invoke: invokeLambdaWithRetry, logError: error => console.error('err: ', error),
    });
}

export async function getExtractPath(documentFullPath) {
    var docFPs = documentFullPath.split('/');
    docFPs.pop();
    return docFPs.join('/');
}

export async function replaceLastOfFile(fname, last, extension) {
    var fparts = fname.split(".");
    fparts[fparts.length - 2] += last;
    fparts[fparts.length - 1] = extension;
    return fparts.join(".");
}

function doFillers(pageData) {
    for (var page = 0; page < pageData.length; page++) {
        for (var row = 0; row < pageData[page].length; row++) {
            for (var col = 0; col < pageData[page][row].length; col++) {
                if (pageData[page][row][col] === null || pageData[page][row][col] === undefined) {
                    pageData[page][row][col] = { "value": "" };
                }
            }
        }
    }
    return pageData;
}

function getLatestTemplateObject(versions) {
    if (!Array.isArray(versions) || versions.length === 0) {
        return null;
    }

    return versions.reduce((latest, current) => {
        const latestVer = Number(latest.TemplateVersionNumber) || 0;
        const currentVer = Number(current.TemplateVersionNumber) || 0;

        return currentVer > latestVer ? current : latest;
    });
}

export async function resolveTemplateVersionFromData(
    templateName,
    templateVersionNumber,
    templates,
    templateVersions
) {
    console.debug("templateName: ", templateName)
    // Templates table (exact match)
    const exactTemplate = templates.find(t =>
        t.TemplateVersionNumber === templateVersionNumber && t.TemplateName === templateName
    );

    if (exactTemplate) {
        return exactTemplate;
    }

    if (!Array.isArray(templateVersions) || templateVersions.length === 0) {
        console.warn("Template not found in TemplateVersions table");
        return templates[0] || null;
    }

    // Try exact version match
    let versionEntry = templateVersions.find(v =>
        v.TemplateVersionNumber === templateVersionNumber && v.TemplateName === templateName
    );

    // Else fallback to latest version
    if (!versionEntry) {
        console.debug("Fetching template from template versions")
        versionEntry = getLatestTemplateObject(templateVersions);
    }

    return versionEntry || templates[0] || null;
}

export async function rebuildJsonDataUsingTemplate(xlData, document, extractValue, maxTemplateCount) {
    let updatedXlData = [];
    let templateList = await fetchTemplateList(undefined, maxTemplateCount, document.templateName, true);
    const matchedTemplateList = templateList?.templates?.filter((item) => item.TemplateName.toString().toLowerCase() === document?.templateName.toString().toLowerCase());
    let templateObj = await resolveTemplateVersionFromData(document?.templateName, document?.TemplateVersionNumber, matchedTemplateList, templateList?.templateVersions);
    const templatePath = templateObj ? templateObj.TemplatePath : null;

    const byteArray = await fetchExcelFromS3(templatePath, extractValue.instanceRegion, extractValue.instanceBucket);
    let templateJsonData = await convertExcelToJson(byteArray);

    // Create a map of current headers and their index
    const currentHeaderRow = xlData[0][0];
    const templateHeaderRow = templateJsonData[0][0];
    const currentHeaderMap = {};
    currentHeaderRow.forEach((col, idx) => {
        const key = col?.value?.toLowerCase()?.trim();
        if (key) currentHeaderMap[key] = idx;
    });

    // Build a map from entity name -> template row index for meaData lookups
    const templateEntityNameIndex = templateHeaderRow.findIndex(
        (col) => col?.value?.toLowerCase()?.trim() === "entity name"
    );
    const templateEntityMap = {};
    if (templateEntityNameIndex !== -1) {
        templateJsonData[0].forEach((templateRow, idx) => {
            if (idx > 0) {
                const eName = templateRow[templateEntityNameIndex]?.value?.toString()?.trim();
                if (eName) templateEntityMap[eName.toLowerCase()] = idx;
            }
        });
    }

    // Start rebuilding the xlData using the template column order
    xlData[0].forEach((row, rowIndex) => {
        const newRow = [];
        templateHeaderRow.forEach((templateCol, insertIndex) => {
            const templateKey = templateCol?.value?.toLowerCase()?.trim();
            const colIndexInCurrent = currentHeaderMap[templateKey];
            if (colIndexInCurrent !== undefined) {
                if (rowIndex > 0 && (templateKey === "meadata type" || templateKey === "meadata rule" || templateKey === "mandatorycheck")) {
                    // Prefer template value for meaData columns so date-format rules are always from template
                    const entityNameIdxInCurrent = currentHeaderMap["entity name"];
                    const entityName = entityNameIdxInCurrent !== undefined
                        ? row[entityNameIdxInCurrent]?.value?.toString()?.trim()
                        : null;
                    const templateRowIdx = entityName ? templateEntityMap[entityName.toLowerCase()] : undefined;
                    const templateValue = templateRowIdx !== undefined
                        ? templateJsonData[0][templateRowIdx][insertIndex]?.value
                        : undefined;
                    newRow.push({ value: row[colIndexInCurrent]?.value || templateValue || '' });
                } else {
                    // Keep the original cell from the correct column
                    newRow.push(row[colIndexInCurrent]);
                }
            } else {
                if (templateKey?.toString() === "linked entity") {
                    newRow.push({ value: templateJsonData[0]?.[rowIndex]?.[insertIndex]?.value || '' });
                }
                else if (templateKey?.toString() === "grouped entities") {
                    newRow.push({ value: templateJsonData[0]?.[rowIndex]?.[insertIndex]?.value || '' });
                }
                else {
                    newRow.push({ value: rowIndex === 0 ? templateCol?.value : '' });
                }
            }
        });
        updatedXlData.push(newRow);
    });
    return [updatedXlData];
}

export async function compareQAFeedback(ext, qa, document, extractValue, maxTemplateCount, xlType, status) {
    const postprocessing = await getParameterFromManager(`ENABLE_POSTPROCESSING_RULE_DURING_QASAVE`);
    if (xlType === "Generic") {
        ext = await rebuildJsonDataUsingTemplate(ext, document, extractValue, maxTemplateCount);
        if (postprocessing || document.processingStatus === "QA Uploaded" || status === "QA Uploaded" || status === "QA Complete") {
            qa = await rebuildJsonDataUsingTemplate(qa, document, extractValue, maxTemplateCount);
        }
    }
    var result = { success: true, added: 0, deleted: 0, modified: 0, diffpack: JSON.parse(JSON.stringify(ext)) };
    if (xlType !== "Generic") return result;

    if (ext.length === qa.length) {
        for (var page = 0; page < ext.length; page++) {
            var colOffset = 0;
            for (var m = 0; m < ext[page][0].length; m++) {
                if (ext[page][0][m].value.toString().toLowerCase().trim().startsWith("output ") === true || ext[page][0][m].value.toString().trim().toLowerCase() === "entity name") {
                    result.diffpack[page][0].splice(m + colOffset + 1, 0, { "value": ext[page][0][m].value.toString().trim().toLowerCase() === "entity name" ? "QA Verify Status" : `Modified ${ext[page][0][m].value}` });
                    for (var ir = 1; ir < ext[page].length; ir++) {
                        result.diffpack[page][ir].splice(m + colOffset + 1, 0, { "value": "" });
                    }
                    colOffset++;
                }
            }

            if (JSON.stringify(ext[page][0]) !== JSON.stringify(qa[page][0]) || JSON.stringify(ext[page][0]) === JSON.stringify(qa[page][0])) {
                for (var row = 1; row < ext[page].length; row++) {
                    let getEntityNameIndex = ext[page][0].findIndex(item => item.value.toLowerCase() === "entity name");
                    if (ext[page][row][getEntityNameIndex]?.value.toString().trim().length !== 0) {
                        const entityNameToFind = ext[page][row][getEntityNameIndex]?.value;
                        let getQAEntityNameIndex = qa[page][0].findIndex(item => item.value.toLowerCase() === "entity name");
                        var colRhs = qa[page].filter(obj => {
                            return obj[getQAEntityNameIndex]?.value === entityNameToFind;
                        });
                        if (colRhs.length === 0) {
                            // if in rhs key not found: removed(deleted)
                            console.warn(`row for entity ${entityNameToFind} in target not found, so deleted`);
                            result.deleted++;
                        } else if (colRhs.length === 1) {
                            if (JSON.stringify(ext[page][row]) !== JSON.stringify(colRhs[0])) {
                                // if in rhs key found new value : change or value emptied(deleted) or value filled(added)
                                colOffset = 2;
                                for (var col = 1; col < ext[page][row].length; col++) {
                                    if (ext[page][0][col].value.toLowerCase().startsWith("output ") === true) {
                                        let getColumnName = ext[page][0][col].value.toLowerCase().startsWith("output ") && ext[page][0][col].value;
                                        let getColumnNameIndex = qa[page][0].findIndex(item => item.value.toLowerCase() === getColumnName.toLowerCase())
                                        if (getColumnNameIndex === -1 || colRhs[0]?.[getColumnNameIndex] === undefined) {
                                            colOffset++;
                                            continue;
                                        }
                                        const extractedValue = ext[page][row][col]?.value ?? "";
                                        const qaValue = colRhs[0][getColumnNameIndex]?.value ?? "";
                                        if (extractedValue !== qaValue) {
                                            if (extractedValue.length === 0) {
                                                console.debug(`field added ${col}`);
                                                result.diffpack[page][row][col + colOffset].value = qaValue;
                                                result.added++;
                                            } else if (qaValue.length === 0) {
                                                result.deleted++;
                                            } else {
                                                console.debug(`field changed ${col}`);
                                                result.diffpack[page][row][col + colOffset].value = qaValue;
                                                result.modified++;
                                            }
                                        }
                                        colOffset++;
                                    }
                                }
                            } else {
                                // if in rhs key found same value : no change
                            }
                        }
                        // else {//more rows matched. which one
                        //     console.log(`duplicate matching rows for entity ${entityNameToFind} in target`);
                        //     return { success: false };
                        // }
                    }
                    for (var rhrow = 1; rhrow < qa[page].length; rhrow++) {
                        let getQAEntityNameValueIndex = qa[page][0].findIndex(item => item.value.toLowerCase() === "entity name");
                        let getEntityNameIndex = ext[page][0].findIndex(item => item.value.toLowerCase() === "entity name");
                        if (qa[page][rhrow][getQAEntityNameValueIndex].value.toString().trim().length !== 0) {
                            const entityNameToFind = qa[page][rhrow][getQAEntityNameValueIndex].value;
                            var colLhs = ext[page].filter(obj => {
                                return obj[getEntityNameIndex].value === entityNameToFind;
                            });
                            if (colLhs.length === 0) {
                                // if in lhs key not found: added
                                console.warn(`row for entity ${entityNameToFind} in target not found, so added`);
                                result.added++;
                            }
                        }
                    }
                }
            } else {
                console.debug("file target is not matching");
                return { success: false };
            }
        }
    } else {
        console.debug("file target is not matching");
        return { success: false };
    }

    const headerRow = result.diffpack[0][0];
    const entityRows = result.diffpack[0].slice(1);
    const columnsToKeep = [];
    const skipIndices = new Set();

    for (let i = 0; i < headerRow.length; i++) {
        if (skipIndices.has(i)) continue;

        const header = headerRow[i].value.trim().toLowerCase();

        const isOutput = header.startsWith("output ");
        const isModifiedOutput = header.startsWith("modified output ");
        const isQAVerify = header === "qa verify status";

        if (isQAVerify) {
            columnsToKeep.push(i);
        } else if (isOutput) {
            const modifiedIndex = i + 1;
            const bothEmpty = entityRows.every(row =>
                row[i]?.value.trim() === "" && row[modifiedIndex]?.value.trim() === ""
            );

            if (!bothEmpty) {
                columnsToKeep.push(i, modifiedIndex);
            }

            skipIndices.add(modifiedIndex);
            i++;
        } else if (isModifiedOutput) {
            continue;
        } else {
            const anyValue = entityRows.some(row => row[i]?.value.trim() !== "");
            if (anyValue) {
                columnsToKeep.push(i);
            }
        }
    }

    // Filter each row to keep only selected columns
    result.diffpack[0] = result.diffpack[0].map(row =>
        columnsToKeep.map(colIdx => row[colIdx])
    );

    let templateRules = {};
    if (document?.templateName) {
        try {
            templateRules = await getTemplateRules(document.templateName);
        } catch (err) {
            console.warn(`compareQAFeedback unable to fetch template rules for ${document.templateName}:`, err?.message || err);
        }
    }
    
    let isCellLevelEnabled = templateRules?.metaData?.enableCellLevelFieldCounts;
    if (isCellLevelEnabled === undefined) {
        try {
            const defaultRules = await getTemplateRules('default');
            isCellLevelEnabled = defaultRules?.metaData?.enableCellLevelFieldCounts === true;
        } catch (err) {}
    } else {
        isCellLevelEnabled = isCellLevelEnabled === true;
    }

    if (isCellLevelEnabled === true) {
        Object.assign(result, countGenericQaFieldChanges(ext, qa));
    }
    return result;
}

export async function savedQA(document, xlData, scratchPad, clientSubNumber, sheetNames, status, notifyCount, extractValue, maxTemplateCount, xlType = "", updateDocRef) {
    if (document?.archivedQa && ['sov', 'loss run'].includes(String(xlType || document.inputFileType || '').toLowerCase())) return archivedSavedDocument(await saveLargeQAFileBackend(document, scratchPad, clientSubNumber, status || 'QA Uploaded', extractValue, xlType, { notifyCount }), document, updateDocRef);
    if (document?.archivedQa) await renewArchivedQaSession(document.archivedQa);
    var pathForExtracts = await getExtractPath(document.documentFullPath);
    var fileName = `${await replaceLastOfFile(document.uploadDocumentName, "_qa", "xlsx")}`;
    var uuidName = uuid();
    var fullPath = `${pathForExtracts}/${uuidName}${fileName}`;
    var jsonFile = `${pathForExtracts}/${uuidName}${await replaceLastOfFile(document.uploadDocumentName, "", "json")}`;
    var jsonScratchPadFile = `${pathForExtracts}/${uuidName}${await replaceLastOfFile(document.uploadDocumentName, "_scratchpad", "json")}`;
    var jsonDiffFile = `${pathForExtracts}/${uuidName}${await replaceLastOfFile(document.uploadDocumentName, "_diff", "json")}`;

    //Update QA Columns in DB 
    var today = new Date();
    var nDate = today.toJSON().slice(0, 10);//YYYY-MM-DD
    //Put in S3
    const useResponsiveSerialization = xlType === "Generic" && status === "QA In Progress";
    let data;
    let serializedQaData;
    if (useResponsiveSerialization) {
        const serialization = await serializeQaDataForSave(xlData);
        serializedQaData = serialization.json;
        console.info("Generic QA save preparation completed", {
            documentId: document?.document_id,
            usedWorker: serialization.usedWorker,
            fallbackReason: serialization.fallbackReason,
            byteLength: Buffer.byteLength(serializedQaData, "utf8"),
        });
    } else {
        const jsonD = JSON.stringify(xlData);
        data = doFillers(JSON.parse(jsonD));
        serializedQaData = JSON.stringify(data);
    }
    await Storage.put(jsonFile, Buffer.from(serializedQaData, 'utf8'), {
        metadata: {
            source: "UI",
            suffix: "_qa",
            documentname: document?.documentName || "",
            templatename: document?.templateName || ""
        }
    });
    await Storage.put(`info-staging/ui/${jsonFile}`, '');
    const workbookSaved = await saveQAFile(fullPath, jsonFile, sheetNames, document, xlType);
    if (document?.archivedQa) {
        if (workbookSaved?.success !== true) throw new Error('The QA workbook was not generated. Your edits were not published.');
        return archivedSavedDocument(await saveLargeQAFileBackend(document, scratchPad, clientSubNumber, status || 'QA Uploaded', extractValue, xlType,
            { reviewJobId: workbookSaved.jobId, notifyCount }), document, updateDocRef);
    }
    //save scratchPad
    await Storage.put(jsonScratchPadFile, Buffer.from(JSON.stringify(scratchPad), 'utf8'));
    if (updateDocRef !== undefined) {
        updateDocRef.current = {
            ...updateDocRef.current,
            updJsonExtractPath: qaStoredValue(jsonFile, document),
            updQAFileFullPath: qaStoredValue(fullPath, document),
        };
    }
    //and then update db
    const updDocument = {
        document_id: document.document_id,
        processingStatus: status || "QA Uploaded",
        qaFileName: qaStoredValue(fileName, document),
        qaFileFullPath: qaStoredValue(fullPath, document),
        jsonExtractpath: qaStoredValue(jsonFile, document),
        qaFileProcessedDate: nDate,
        clientQASubmissionNum: clientSubNumber,
        NumFieldsQAModified: scratchPad.editedRows?.length
    };
    const user = await getAuthenticatedUserForQA();
    const userEmail = user.attributes.email;
    var body = {
        "access_token": user.signInUserSession.idToken.jwtToken,
        "target": "updateDocument",
        "updateDocumentsInput": updDocument,
        ...(document?.archivedQa ? { archivedQa: document.archivedQa } : {})
    };
    var init = {
        body: body
    };
    let res = await invokeLambdaWithRetry("instanceHandler", init);
    if (document?.archivedQa) {
        const saved = res?.response?.data?.updateDocuments;
        if (!saved?.archivedQa) throw new Error('Archived QA changes were not committed. Reload before retrying.');
        document = saved;
        if (updateDocRef) updateDocRef.current = saved;
    }
    var updSubmissionReport = {
        submissionIdentifier: document.submissionIdentifier,
        document_id: document.document_id,
        QASaveDateTime: "NOW",
        QASaveUser: userEmail,
    };


    if ((notifyCount === 0 && status === "QA In Progress")) {
        notifyUser({ "username": document.submittedby, "processorname": userEmail, "fileName": document.documentName, "option": "qaUploaded", "submissionIdentifier": document.submissionIdentifier });
    }
    const uploadDocumentFullPath = document.uploadDocumentFullPath?.replace(/\.xlsx$/, ".json");
    if ((document.jsonMarkCompletePath !== null || uploadDocumentFullPath !== null) && (status === "QA Uploaded" || status === "QA Complete")) {
        var origData = await loadS3File(document.jsonMarkCompletePath || uploadDocumentFullPath);
        var compRes = await compareQAFeedback(origData, data, document, extractValue, maxTemplateCount, xlType, status);
        if (compRes.success !== false && compRes.diffpack !== undefined) {
            await Storage.put(jsonDiffFile, Buffer.from(JSON.stringify(compRes.diffpack), 'utf8'));
            updSubmissionReport.NumFieldsQAModified = compRes.modified;
            updSubmissionReport.NumFieldsQAAdded = compRes.added;
            updSubmissionReport.NumFieldsQADeleted = compRes.deleted;
            updSubmissionReport.ExtractionQADifferencesJsonPath = jsonDiffFile;
        }
    }
    body = {
        "access_token": user.signInUserSession.idToken.jwtToken,
        "target": "updateSubmissionsReport",
        "submissionsReportInput": updSubmissionReport,
        ...(document?.archivedQa ? { archivedQa: document.archivedQa } : {})
    };
    init = {
        body: body
    };

    res = await invokeLambdaWithRetry("instanceHandler", init);
    if (status === "QA Complete") {
        notifyUser({ "username": document.submittedby, "processorname": userEmail, "fileName": document.documentName, "option": "qaComplete", "submissionIdentifier": document.submissionIdentifier });
        logAudit(document.document_id, document.submissionIdentifier, "QA", status, "UI", undefined, undefined).then((data) => { });
        logAudit(document.document_id, document.submissionIdentifier, "QA", "Mark QA Complete", "UI", undefined, undefined).then((data) => { });
    } else if (status === "QA In Progress") {
        void (async () => {
            await logAudit(document.document_id, document.submissionIdentifier, "QA", "Save", "UI", undefined, undefined);
            await logAudit(document.document_id, document.submissionIdentifier, "QA", "QA In Progress", "UI", undefined, undefined);
        })();
    } else {
        logAudit(document.document_id, document.submissionIdentifier, "QA", "QA Uploaded", "UI", undefined, undefined).then((data) => { });
        logAudit(document.document_id, document.submissionIdentifier, "QA", "Save", "UI", undefined, undefined).then((data) => { });
    }
    try {
        body = {
            "target": "extractDocument",
            "access_token": user.signInUserSession.idToken.jwtToken,
            "option": "submission_data_lake",
            ...(document?.archivedQa ? { archivedQa: document.archivedQa } : {}),
            "submissionIdentifier": document.submissionIdentifier,
            "document_id": document.document_id,
            "templateName": document.templateName,
            "inputfile": document.uploadDocumentFullPath,
            ...(status === "QA Complete" ? {
                "meaOpsAction": "OnSubmissionQAComplete",
                "meaOpsLastModifiedBy": user?.attributes?.email || user?.username
            } : {})
        };
        init = {
            body: JSON.stringify(body)
        };
        res = await invokeLambdaWithRetry("instanceHandler", init);
        console.debug("res submission_data_lake -> ", res);
    }
    catch (err) {
        console.error("err in submission_data_lake -> ", err);
    }
    return document?.archivedQa ? document : undefined;
}

export async function saveLargeQAFileBackend(document, scratchPad, clientSubNumber, status, extractValue, xlType = "", options = {}) {
    return requestLargeQaSave(document, scratchPad, clientSubNumber, status, xlType, options,
        { authenticate: getAuthenticatedUserForQA, invoke: invokeLambdaWithRetry, requestId: uuid });
}

export async function syncQaConsolidatedOutputBackend(document, xlType = "") {
    const user = await getAuthenticatedUserForQA();
    const result = await invokeLambdaWithRetry("instanceHandler", {
        body: {
            access_token: user.signInUserSession.idToken.jwtToken,
            target: "sync-qa-consolidated-output",
            document,
            inputFileType: xlType || document?.inputFileType
        }
    });
    let response = result;
    const statusCodes = [];
    const statuses = [];
    let responseError;
    for (let depth = 0; depth < 4 && response && typeof response === "object"; depth++) {
        responseError = responseError || response.errorDescription || response.error;
        if (response.statusCode !== undefined) statusCodes.push(Number(response.statusCode));
        statuses.push(response.apiStatus, response.status, response.success === false ? "failed" : undefined);
        if (response.response === undefined || response.response === response) break;
        response = response.response;
    }
    if (responseError || statusCodes.some(statusCode => statusCode >= 400 || statusCode === 202)
        || statuses.some(status => ["pending", "queued", "running", "in progress", "failed", "failure", "error"].includes(`${status || ""}`.trim().toLowerCase()))) {
        throw new Error(responseError || "QA consolidated synchronization did not complete successfully.");
    }
    const isExpectedNoop = response?.unchanged === true || response?.alreadyConsolidated === true
        || response?.disabled === true && response?.synchronized === false;
    if (!response || typeof response !== "object" || response.error || response.errorDescription
        || response.synchronized !== true && !isExpectedNoop || response.disabled === true && response.synchronized !== false || response.unsupported === true) {
        throw new Error(response?.errorDescription || response?.error || "QA consolidated synchronization did not complete successfully.");
    }
    return response;
}

export async function savedQALargeFileBackend(document, scratchPad, clientSubNumber, status, extractValue, xlType = "", options = {}) {
    return saveLargeQAFileBackend(document, scratchPad, clientSubNumber, status, extractValue, xlType, options);
}

export async function sendLargeQAFileBackend(document, scratchPad, clientSubNumber, status, extractValue, xlType = "", options = {}) {
    return requestLargeQaSend(document, scratchPad, clientSubNumber, status, xlType, options,
        { authenticate: getAuthenticatedUserForQA, invoke: invokeLambdaWithRetry, requestId: uuid });
}

export const SEND_QA_ASYNC_ACCEPTED_MESSAGE = "Send QA accepted and queued for background processing";
export const SEND_QA_ASYNC_DUPLICATE_MESSAGE = "Send QA is already queued or processing in the background";
export const SEND_QA_REQUEST_FAILURE_CODE = Object.freeze({
    AUTHENTICATION: "authentication",
    SOURCE_DOCUMENT: "source-document",
    QA_DATA_PREPARATION: "qa-data-preparation",
    BATCH_NOT_READY: "batch-not-ready",
    AUTHORIZATION: "authorization",
    RATE_LIMITED: "rate-limited",
    PAYLOAD_TOO_LARGE: "payload-too-large",
    DELIVERY_SERVICE: "delivery-service",
    DELIVERY_TIMEOUT: "delivery-timeout",
    ENDPOINT_NOT_FOUND: "endpoint-not-found",
    DELIVERY_CONFIGURATION: "delivery-configuration",
    CONFIGURATION_OR_DELIVERY: "configuration-or-delivery",
    UNEXPECTED: "unexpected"
});

export function isSendQaAsyncAcceptedResponse(message) {
    return typeof message === "string" && (
        message === SEND_QA_ASYNC_ACCEPTED_MESSAGE ||
        message === SEND_QA_ASYNC_DUPLICATE_MESSAGE
    );
}

export function isSendQaAsyncDuplicateResponse(message) {
    return message === SEND_QA_ASYNC_DUPLICATE_MESSAGE;
}

function unwrapSendQaResponse(result) {
    let current = result;
    for (let depth = 0; depth < 5; depth++) {
        if (typeof current === "string") {
            try {
                current = JSON.parse(current);
            } catch {
                return current;
            }
        }
        if (!current || typeof current !== "object") return current;
        if (current.accepted === true || current.success === false || current.error === true) return current;
        if (current.body !== undefined) {
            current = current.body;
            continue;
        }
        if (current.response !== undefined) {
            current = current.response;
            continue;
        }
        return current;
    }
    return current;
}

function classifySendQaResponseFailure(result, response) {
    const suppliedCode = response?.failureCode || response?.code;
    if (Object.values(SEND_QA_REQUEST_FAILURE_CODE).includes(suppliedCode)) {
        return suppliedCode;
    }
    const statusCode = Number(response?.delivery?.statusCode ?? response?.statusCode ?? result?.statusCode);
    if (response?.batchNotReady === true || statusCode === 409) {
        return SEND_QA_REQUEST_FAILURE_CODE.BATCH_NOT_READY;
    }
    if (statusCode === 401 || statusCode === 403) {
        return SEND_QA_REQUEST_FAILURE_CODE.AUTHORIZATION;
    }
    if (statusCode === 429) {
        return SEND_QA_REQUEST_FAILURE_CODE.RATE_LIMITED;
    }
    if (statusCode === 413) {
        return SEND_QA_REQUEST_FAILURE_CODE.PAYLOAD_TOO_LARGE;
    }
    if ([404, 410].includes(statusCode)) {
        return SEND_QA_REQUEST_FAILURE_CODE.ENDPOINT_NOT_FOUND;
    }
    if ([408, 504].includes(statusCode)) {
        return SEND_QA_REQUEST_FAILURE_CODE.DELIVERY_TIMEOUT;
    }
    if (statusCode >= 500) {
        return SEND_QA_REQUEST_FAILURE_CODE.DELIVERY_SERVICE;
    }
    return SEND_QA_REQUEST_FAILURE_CODE.CONFIGURATION_OR_DELIVERY;
}

function normalizeSendQaDeliveryDetails(delivery) {
    if (!delivery || typeof delivery !== "object") return undefined;
    const statusCode = Number(delivery.statusCode);
    const transmitterType = ["rest", "auth-rest", "sftp", "legacy"].includes(delivery.transmitterType)
        ? delivery.transmitterType
        : undefined;
    return {
        ...(transmitterType ? { transmitterType } : {}),
        ...(Number.isInteger(statusCode) && statusCode >= 100 && statusCode <= 599 ? { statusCode } : {}),
        attemptsUsed: Math.max(0, Number(delivery.attemptsUsed) || 0),
        configuredRetryCount: Math.max(0, Number(delivery.configuredRetryCount) || 0),
        retryable: delivery.retryable === true
    };
}

function classifySendQaInvocationException(error) {
    // Inspect both fields: Node errors are commonly { name: "Error", code: "ETIMEDOUT" },
    // where a truthy generic name would otherwise hide the meaningful code.
    const errorName = `${error?.name || ""} ${error?.code || ""}`.trim().toLowerCase();
    const statusCode = Number(error?.$metadata?.httpStatusCode ?? error?.statusCode);
    if (errorName.includes("requestentitytoolarge") || errorName.includes("payloadtoolarge") || statusCode === 413) {
        return SEND_QA_REQUEST_FAILURE_CODE.PAYLOAD_TOO_LARGE;
    }
    if (errorName.includes("accessdenied") || errorName.includes("unauthorized") || statusCode === 401 || statusCode === 403) {
        return SEND_QA_REQUEST_FAILURE_CODE.AUTHORIZATION;
    }
    if (errorName.includes("throttl") || errorName.includes("ratelimit") || errorName.includes("toomanyrequests") || statusCode === 429) {
        return SEND_QA_REQUEST_FAILURE_CODE.RATE_LIMITED;
    }
    if (errorName.includes("timeout") || errorName.includes("timedout") || statusCode === 408 || statusCode === 504) {
        return SEND_QA_REQUEST_FAILURE_CODE.DELIVERY_TIMEOUT;
    }
    return SEND_QA_REQUEST_FAILURE_CODE.DELIVERY_SERVICE;
}

function buildSendQaInvocationDelivery(failureCode) {
    return {
        attemptsUsed: 0,
        configuredRetryCount: 0,
        retryable: [
            SEND_QA_REQUEST_FAILURE_CODE.RATE_LIMITED,
            SEND_QA_REQUEST_FAILURE_CODE.DELIVERY_TIMEOUT,
            SEND_QA_REQUEST_FAILURE_CODE.DELIVERY_SERVICE
        ].includes(failureCode)
    };
}

function resolveAcceptedSendQaReference(response, diagnosticReference) {
    // A duplicate is rejected without dispatching a worker for this request, so the
    // locally generated reference would appear in no log. Show the active request's
    // stored reference, or none at all.
    const isDuplicate = response?.duplicate === true || isSendQaAsyncDuplicateResponse(response?.message);
    return isDuplicate
        ? response?.diagnosticReference
        : (response?.diagnosticReference || diagnosticReference);
}

export function interpretLargeQaSendResult(sendResponse, diagnosticReference) {
    if (!sendResponse?.success || sendResponse?.sendResult === undefined || sendResponse?.sendResult === null) {
        return {
            success: false,
            failureCode: SEND_QA_REQUEST_FAILURE_CODE.CONFIGURATION_OR_DELIVERY,
            diagnosticReference
        };
    }
    const response = unwrapSendQaResponse(sendResponse.sendResult);
    if (response?.success === false || response?.error === true || Number(response?.statusCode) >= 400) {
        const failureCode = classifySendQaResponseFailure(sendResponse.sendResult, response);
        return {
            success: false,
            failureCode,
            diagnosticReference: response?.diagnosticReference || diagnosticReference,
            delivery: normalizeSendQaDeliveryDetails(response?.delivery)
        };
    }
    if (response?.accepted === true) {
        return {
            success: true,
            message: response.message || SEND_QA_ASYNC_ACCEPTED_MESSAGE,
            diagnosticReference: resolveAcceptedSendQaReference(response, diagnosticReference)
        };
    }
    return {
        success: true,
        message: typeof response === "string" ? response : (response?.message || "Successfully sent the notification for the QA data"),
        diagnosticReference
    };
}

export async function notifyClientWithDetails(subid, docname, clientSubNumber, document_id, xlType, templateName, selectMode = "all", status = "QA Uploaded", options = {}) {
    let requestStage = SEND_QA_REQUEST_FAILURE_CODE.AUTHENTICATION;
    const diagnosticReference = options?.diagnosticReference;
    try {
        const user = await getAuthenticatedUserForQA();
        const userEmail = user.attributes.email;
        let resMsg = "";
        requestStage = SEND_QA_REQUEST_FAILURE_CODE.SOURCE_DOCUMENT;
        const res = options?.archivedQa
            ? await fetchArchivedQaSource(subid, options.archivedQa)
            : await fetchMsg(subid);
        if (!res?.data?.listDocumentsAnyWithMsg) {
            return {
                success: false,
                failureCode: SEND_QA_REQUEST_FAILURE_CODE.SOURCE_DOCUMENT
            };
        }
        const body = {
            access_token: user.signInUserSession.idToken.jwtToken,
            data: {
                "submissionid": subid,
                "documentname": docname,
                "submission_number": clientSubNumber.toString().trim(),
                "templateName": templateName,// templateName associated with this merged file
                "originalMsgFileName": xlType?.toLowerCase()?.trim() === "generic" ? (res.data.listDocumentsAnyWithMsg.length === 1 ? res.data.listDocumentsAnyWithMsg[0].documentName : undefined) : docname,// - Include the original .msg or .eml file associated with this submission.
                "originalInputFileName": xlType?.toLowerCase()?.trim() === "generic" ? (res.data.listDocumentsAnyWithMsg.length === 1 ? res.data.listDocumentsAnyWithMsg[0].documentName : undefined) : docname,
                "document_id": document_id,
                "status": status,
                "QAUserID": userEmail,
                "selectMode": selectMode
            },
            "target": "notifyclient",
            ...(options?.archivedQa ? { archivedQa: options.archivedQa } : {}),
            diagnosticReference,
            "asyncResponse": true
        };
        const init = {
            body: JSON.stringify(body)
        };

        requestStage = SEND_QA_REQUEST_FAILURE_CODE.DELIVERY_SERVICE;
        const result = await invokeLambdaWithRetry("instanceHandler", init);
        const response = unwrapSendQaResponse(result);
        if (
            !result ||
            result?.error ||
            response?.success === false ||
            response?.error ||
            Number(result?.statusCode) >= 400 ||
            Number(response?.statusCode) >= 400
        ) {
            const failureCode = classifySendQaResponseFailure(result, response);
            console.error("Send QA request was rejected", {
                diagnosticReference,
                failureCode,
                statusCode: Number(response?.delivery?.statusCode ?? response?.statusCode ?? result?.statusCode) || 0
            });
            return {
                success: false,
                failureCode,
                diagnosticReference: response?.diagnosticReference || diagnosticReference,
                delivery: normalizeSendQaDeliveryDetails(response?.delivery)
            };
        }
        if (response?.accepted === true) {
            return {
                success: true,
                message: response.message || SEND_QA_ASYNC_ACCEPTED_MESSAGE,
                diagnosticReference: resolveAcceptedSendQaReference(response, diagnosticReference)
            };
        }
        resMsg = "Successfully sent the notification for the QA data";
        return { success: true, message: resMsg, diagnosticReference };
    } catch (err) {
        const failureCode = requestStage === SEND_QA_REQUEST_FAILURE_CODE.DELIVERY_SERVICE
            ? classifySendQaInvocationException(err)
            : requestStage;
        console.error("Send QA request preparation failed", {
            code: failureCode,
            diagnosticReference,
            errorType: err?.name || "Error"
        });
        return {
            success: false,
            failureCode,
            diagnosticReference,
            delivery: buildSendQaInvocationDelivery(failureCode)
        };
    }
}

export async function notifyClient(subid, docname, clientSubNumber, document_id, xlType, templateName, selectMode = "all", status = "QA Uploaded", options = {}) {
    const result = await notifyClientWithDetails(subid, docname, clientSubNumber, document_id, xlType, templateName, selectMode, status, options);
    return result.success ? result.message : false;
}

export async function handleUpdateSubmissionReport(updSubmissionReport, archivedQa) {
    const user = await Auth.currentAuthenticatedUser({
        bypassCache: true  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
    });
    const body = {
        "access_token": user.signInUserSession.idToken.jwtToken,
        "target": "updateSubmissionsReport",
        "submissionsReportInput": updSubmissionReport,
        ...(archivedQa ? { archivedQa } : {})
    };
    const init = {
        body: body
    };
    await invokeLambdaWithRetry("instanceHandler", init);
}

function normalizeSubmissionUpdateKey(value) {
    return String(value || "")
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "_")
        .replace(/^_+|_+$/g, "");
}

function getOutputColumnsFromHeader(headerRow = []) {
    return headerRow
        .map((columnName, columnIndex) => ({ columnName, columnIndex }))
        .filter(({ columnName }) => normalizeSubmissionUpdateKey(columnName).startsWith("output_"));
}

function getOutputSuffix(columnName) {
    const outputMatch = String(columnName || "").trim().toLowerCase().match(/^output\s*(\d+)$/);
    const outputIndex = outputMatch ? Number(outputMatch[1]) : 1;
    return outputIndex > 1 ? `_out${outputIndex}` : "";
}

function getHeaderRow(sheetRows = []) {
    // Read the first row as the column header row.
    return Array.isArray(sheetRows?.[0]) ? sheetRows[0].map((cell) => cell?.value) : [];
}

function findEntityRowIndex(sheetRows = [], entityColumnIndex, entityName) {
    if (!Array.isArray(sheetRows) || entityColumnIndex === -1 || !entityName) return -1;
    const normalizedEntityName = String(entityName).trim().toLowerCase();
    return sheetRows.findIndex((row, rowIndex) => rowIndex !== 0 && String(row?.[entityColumnIndex]?.value || "").trim().toLowerCase() === normalizedEntityName);
}

const buildSubmissionUpdatePayload = (previousSavedSheet, currentEditedSheet, templateJsonData = []) => {
    if (!Array.isArray(previousSavedSheet) || !Array.isArray(currentEditedSheet) || !previousSavedSheet.length || !currentEditedSheet.length) return {};
    const previousHeaderRow = getHeaderRow(previousSavedSheet);
    const currentHeaderRow = getHeaderRow(currentEditedSheet);

    const previousEntityColumnIndex = previousHeaderRow.findIndex((value) => normalizeSubmissionUpdateKey(value) === "entity_name");
    const currentEntityColumnIndex = currentHeaderRow.findIndex((value) => normalizeSubmissionUpdateKey(value) === "entity_name");
    if (previousEntityColumnIndex === -1 || currentEntityColumnIndex === -1) return {};

    // Use the template sheet that contains both the entity column and the AI field mapping.
    const templateSheetRows = (Array.isArray(templateJsonData) ? templateJsonData.find((sheetRows) => {
        const headerRow = getHeaderRow(sheetRows);
        return headerRow.some((value) => normalizeSubmissionUpdateKey(value) === "entity_name") &&
            headerRow.some((value) => ["ai_fields", "ai_field_name", "ai_field"].includes(normalizeSubmissionUpdateKey(value)));
    }) : null) || templateJsonData?.[0] || [];
    const templateHeaderRow = getHeaderRow(templateSheetRows);
    const templateEntityColumnIndex = templateHeaderRow.findIndex((value) => normalizeSubmissionUpdateKey(value) === "entity_name");
    const templateAiFieldColumnIndex = templateHeaderRow.findIndex((value) => ["ai_fields", "ai_field_name", "ai_field"].includes(normalizeSubmissionUpdateKey(value)));
    const getAiFieldName = (entityName) => {
        if (templateEntityColumnIndex === -1 || templateAiFieldColumnIndex === -1 || !entityName || !Array.isArray(templateSheetRows)) {
            return "";
        }
        const matchedRowIndex = findEntityRowIndex(templateSheetRows, templateEntityColumnIndex, entityName);
        return matchedRowIndex === -1 ? "" : String(templateSheetRows[matchedRowIndex]?.[templateAiFieldColumnIndex]?.value || "").trim();
    };

    const previousOutputColumns = getOutputColumnsFromHeader(previousHeaderRow);
    const currentOutputColumns = getOutputColumnsFromHeader(currentHeaderRow);
    const updates = {};
    for (let rowIndex = 1; rowIndex < currentEditedSheet.length; rowIndex += 1) {
        const currentRow = currentEditedSheet[rowIndex] || [];
        const entityName = currentRow[currentEntityColumnIndex]?.value;
        const aiFieldName = getAiFieldName(entityName);
        if (!entityName || !aiFieldName) continue;

        // Match the same entity in the saved sheet so row order does not matter.
        const previousRowIndex = findEntityRowIndex(previousSavedSheet, previousEntityColumnIndex, entityName);
        if (previousRowIndex === -1) continue;

        const previousRow = previousSavedSheet[previousRowIndex] || [];
        for (const { columnName, columnIndex } of currentOutputColumns) {
            const previousColumn = previousOutputColumns.find(({ columnName: previousColumnName }) => normalizeSubmissionUpdateKey(previousColumnName) === normalizeSubmissionUpdateKey(columnName));
            const previousText = String(previousColumn ? previousRow[previousColumn.columnIndex]?.value : "").trim();
            const currentValue = currentRow[columnIndex]?.value;
            const currentText = String(currentValue === undefined || currentValue === null ? "" : currentValue).trim();
            // Emit only the changed output values.
            if (previousText !== currentText) updates[`${normalizeSubmissionUpdateKey(aiFieldName)}${getOutputSuffix(columnName)}`] = currentText;
        }
    }
    return updates;
};

async function getSubmissionSourceSheet(documentContext = {}) {
    const sourcePath =
        documentContext?.jsonExtractpath ||
        documentContext?.qaFileFullPath ||
        documentContext?.jsonMarkCompletePath ||
        documentContext?.uploadDocumentFullPath;

    if (!sourcePath) {
        return null;
    }

    if (sourcePath.toLowerCase().endsWith(".xlsx")) {
        return await convertExcelToJson(await fetchExcelFromS3(sourcePath));
    }

    return JSON.parse(await fetchJsonData({ docPath: sourcePath }));
}

export async function emitSubmissionUpdateEvent(documentContext, xlData, templateJsonData, xlTypeForUpdate, isPlatform = false) {
    if (!isPlatform || xlTypeForUpdate !== "Generic") {
        return;
    }

    try {
        const previousSavedSheet = await getSubmissionSourceSheet(documentContext);
        if (!previousSavedSheet) {
            return;
        }

        const updates = buildSubmissionUpdatePayload(previousSavedSheet?.[0], xlData?.[0] || xlData, templateJsonData);
        if (Object.keys(updates).length === 0) {
            return;
        }

        const user = await getAuthenticatedUserForQA();

        const init = {
            body: JSON.stringify({
                target: "handleMeaOpsDetails",
                action: "OnSubmissionUpdate",
                access_token: user.signInUserSession.idToken.jwtToken,
                payload: {
                    source: "QA_TOOL",
                    submissionIdentifier: documentContext?.submissionIdentifier,
                    document_id: documentContext?.document_id,
                    lastModifiedBy: user?.attributes?.email || user?.username || "",
                    updates,
                },
            }),
        };
        await invokeLambdaWithRetry("instanceHandler", init, "Event");
    } catch (error) {
        console.warn("OnSubmissionUpdate emit skipped", error?.message || error);
    }
}
//Send QA Data ends

export async function fetchTemplateList(item, maxTemplateCount, templateName = "", returnFullData = false) {
    try {
        const user = await Auth.currentAuthenticatedUser({
            bypassCache: true, // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
        });
        const body = {
            "access_token": user.signInUserSession.idToken.jwtToken,
            "count": -1,
            "rowStart": 0,
            "pageSize": maxTemplateCount,
            "searchTemplateName": templateName,
            "mode": "like",
            "fetchTemplateVersion": returnFullData,
            "target": "fetchTemplateList",
            "document": item
        };
        const init = {
            body: body,
        };
        // if (data !== undefined) {
        //     return JSON.parse(uint8Decode(data.Payload)).response;
        // }
        const data = await invokeLambdaWithRetry("instanceHandler", init);
        if (returnFullData === true) {
            return data;
        }
        return data?.templates;
    } catch (err) {
        console.error("err: ", err);
        return false;
    }
}

export const checkMacroAndUnmappedStatus = async () => {
    return { macroDone: false, copyUnmappedDone: false };
};

export const invokeWarrantyAssessment = async (target, payload = {}) => {
    try {
        const user = await Auth.currentAuthenticatedUser({ bypassCache: true });
        const body = {
            access_token: user.signInUserSession.idToken.jwtToken,
            target,
            ...payload
        };
        const init = { body };
        const data = await invokeLambdaWithRetry("instanceHandler", init);
        return data;
    } catch (err) {
        console.error('err: ', err);
        return false;
    }
}

export async function updateTransformationJSONData(documentDetails, extractValue, updatedJson, updatedSheetData = {}, removeSheetData, reset, isResetMapping) {
    if (documentDetails?.archivedQa) return requestArchivedSovMetadata(documentDetails, { updatedJson, updatedSheetData, removeSheetData, reset, isResetMapping }, { fetchMetadata: fetchJSONFromS3, authenticate: options => Auth.currentAuthenticatedUser(options), invoke: invokeLambdaWithRetry });
    let documentsMeta = {};
    let jsonFilePath = `${documentDetails?.documentFullPath.split('/')[0]}/DocumentsMeta/${documentDetails.document_id}.json`;
    let jsonData = await fetchJSONFromS3(jsonFilePath);
    documentsMeta = jsonData || {};

    let sheetData = {};
    if (reset?.resetSheet === true) {
        if (documentsMeta?.sheetData?.length > 0) {
            let currentSheetData = documentsMeta.sheetData.filter(i => i.inputSheetName !== reset?.inputSheetName);
            sheetData = { sheetData: currentSheetData };
        }
    } else if (Object.keys(updatedSheetData).length > 0) {
        if (documentsMeta?.sheetData?.length > 0) {
            let currentSheetData = documentsMeta.sheetData.filter(i => i.inputSheetName === updatedSheetData?.inputSheetName);
            if (currentSheetData.length > 0) {
                sheetData = {
                    sheetData: documentsMeta.sheetData.map(i => {
                        if (i.inputSheetName === updatedSheetData?.inputSheetName) {
                            if (removeSheetData) {
                                return {
                                    inputSheetName: i.inputSheetName,
                                    inputHeaderRowNumber: updatedSheetData.inputHeaderRowNumber,
                                    childInputHeaderRowNumber: updatedSheetData.childInputHeaderRowNumber,
                                };
                            } else {
                                let updatedItem = { ...i, ...updatedSheetData };
                                // If resetMapping = true, remove qaModKeyValues if it exists
                                if (isResetMapping && updatedItem.qaModKeyValues) {
                                    updatedItem = {
                                        ...updatedItem,
                                        transformationFilePath: documentDetails?.uploadDocumentFullPath,
                                    };
                                    delete updatedItem.qaModKeyValues;
                                }

                                return updatedItem;
                            }
                        }
                        return i;
                    }).sort((a, b) => {
                        const origSheetNames = updatedSheetData?.origSheetNames || [];

                        const indexA = origSheetNames.indexOf(a.inputSheetName);
                        const indexB = origSheetNames.indexOf(b.inputSheetName);

                        return (indexA === -1 ? Infinity : indexA) - (indexB === -1 ? Infinity : indexB);
                    })
                }
            } else {
                sheetData = { sheetData: [...documentsMeta.sheetData, updatedSheetData] };
            }
        } else {
            sheetData = { sheetData: [updatedSheetData] };
        }
    }

    documentsMeta = {
        ...documentsMeta,
        ...updatedJson,
        ...sheetData
    };
    // to update/create json file
    let resp = await updateToS3(jsonFilePath, documentsMeta);
    if (reset?.resetSheet === true) {
        const sanitizedSheetName = `${reset?.inputSheetName}`
            .replace(/[\\/:*?"<>|]/g, "_")
            .replace(/\s+/g, "_");
        const headerRowIndex = reset?.inputHeaderRowNumber ?? 1;
        const childHeaderRowIndex = reset?.childInputHeaderRowNumber;
        const mappedDataPath = `${documentDetails?.documentFullPath.split('/')[0]}/DocumentsMeta/MappedData/${documentDetails.document_id}_${sanitizedSheetName}_orchestration_${headerRowIndex}${childHeaderRowIndex ? "_" + childHeaderRowIndex : ""}.json`;
        await deleteFromS3(mappedDataPath);
        try {
            const apiStatusFilePath = `${documentDetails?.documentFullPath.split('/')[0]}/api_status.json`;
            const apiStatusJson = await fetchJSONFromS3(apiStatusFilePath);
            const apiCallKey = `fetch-mapped-data_${documentDetails.document_id}_${reset?.inputSheetName}`;
            if (apiStatusJson && Object.prototype.hasOwnProperty.call(apiStatusJson, apiCallKey)) {
                delete apiStatusJson[apiCallKey];
                await updateToS3(apiStatusFilePath, apiStatusJson);
            }
        } catch (error) {
            console.debug("clear api_status on reset error:", error);
        }
    }
    return resp;
}

export async function fetchSovAnalyseSnapshot(documentDetails) {
    return loadSovAnalyseMetadata(documentDetails, async key =>
        storageResultToBlob(await fetchFromS3(key)));
}

export async function fetchTransformationJSONData(documentDetails, extractValue) {
    let jsonFilePath = `${documentDetails?.documentFullPath?.split('/')[0]}/DocumentsMeta/${documentDetails?.document_id}.json`;
    let jsonData = await fetchJSONFromS3(jsonFilePath);
    return jsonData;
}

export async function fetchExcelSheetData(instanceExcelDetails, checkSheetName) {
    let buffer = await fetchExcelFromS3(instanceExcelDetails.docPath, instanceExcelDetails.instanceRegion, instanceExcelDetails.instanceBucket);
    const workbook = XLSX.read(buffer, { type: "array", sheetRows: 1 });
    const worksheet = workbook.Sheets[checkSheetName];
    if (!worksheet) return {};
    const firstRow = {};
    for (const cellAddress in worksheet) {
        if (cellAddress[0] === '!' || !Object.prototype.hasOwnProperty.call(worksheet, cellAddress)) continue;

        const cell = worksheet[cellAddress];
        const colIndex = cellAddress.match(/[A-Z]+/)[0];

        if (!firstRow[colIndex]) {
            firstRow[colIndex] = cell.v;
        }
    }
    return firstRow;
}

export async function receiveStrippedExtract(inpDocument, fPath, uploadDocumentFullPath) {
    try {
        const user = await Auth.currentAuthenticatedUser({
            bypassCache: true, // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
        });
        const body = {
            access_token: user.signInUserSession.idToken.jwtToken,
            target: "stripped-extract",
            submissionIdentifier: inpDocument.submissionIdentifier,
            document_id: inpDocument.document_id,
            fPath: fPath,
            uploadDocumentFullPath: uploadDocumentFullPath,
        };
        const init = {
            body: body,
        };
        await invokeLambdaWithRetry("instanceHandler", init);
    } catch (err) {
        console.error(err);
    }
}

export async function downloadJsonFile(jsonFile) {
    let s3Path = await getTrfFile(
        jsonFile?.updJsonExtractPath !== undefined ? jsonFile?.updJsonExtractPath : (jsonFile?.jsonExtractpath || jsonFile?.qaFileFullPath),
        jsonFile?.jsonExtractOriginalpath,
        jsonFile?.submissionIdentifier,
        jsonFile?.document_id
    );
    s3Path = s3Path.path;
    await downloadS3Object(s3Path, getExtractedJsonDownloadName(jsonFile));
}

export async function downloadExtractedFile(docPath, documentFileName) {
    const templateController = await getParameterFromManager(
        "TEMPLATE_CONTROLLER"
    );
    var fPath = docPath;
    if (
        templateController &&
        (templateController.jsonDownloadColumns ||
            templateController.jsonDontDownloadColumns)
    ) {
        fPath = await replaceLastOfFile(fPath, "_stripped", "xlsx");
        console.debug('fPath :>> ', fPath);
        var exists = await doesFileExist(fPath);
        if (exists !== true) {
            await receiveStrippedExtract(
                document,
                fPath,
                docPath
            );
        }
    }

    await downloadS3Object(fPath, documentFileName);
}

const removeWordAFterLastHypen = (sheetName) => {
    let lastHyphenIndex = sheetName.lastIndexOf('-');
    let result;
    if (lastHyphenIndex !== -1) {
        result = sheetName.trim().substring(0, lastHyphenIndex).trim();
    } else {
        result = sheetName.trim();
    }
    return result;
}

const EXCEL_MAX_SHEET_NAME_LENGTH = 31;

const buildDownloadSheetName = (sheetName, existingSheetNames = []) => {
    const normalizeSheetName = value => `${value || ""}`.trim().toLowerCase();
    const baseName = `${sheetName || "Sheet1"}`.trim() || "Sheet1";
    const usedNames = new Set(existingSheetNames.map(normalizeSheetName));
    let candidate = baseName.slice(0, EXCEL_MAX_SHEET_NAME_LENGTH).trim();
    if (!usedNames.has(normalizeSheetName(candidate))) {
        return candidate;
    }

    for (let duplicateIndex = 2; duplicateIndex < 1000; duplicateIndex++) {
        const suffix = ` (${duplicateIndex})`;
        const truncatedBase = baseName.slice(0, Math.max(1, EXCEL_MAX_SHEET_NAME_LENGTH - suffix.length)).trim();
        candidate = `${truncatedBase}${suffix}`;
        if (!usedNames.has(normalizeSheetName(candidate))) {
            return candidate;
        }
    }

    return `${baseName.slice(0, EXCEL_MAX_SHEET_NAME_LENGTH - 3).trim()}...`;
}

function getTransformedDownloadFileName(documentFileName) {
    if (documentFileName.endsWith('.xls')) {
        let docname = documentFileName.replace(/(\.[^.]+)$/, '-Transformed$1.xlsx');
        return docname.replace(".xls", "");
    }
    return documentFileName.replace(/(\.[^.]+)$/, '-Transformed$1');
}

function getSheetDownloadFileName(documentFileName, sheetName) {
    const transformedFileName = getTransformedDownloadFileName(documentFileName);
    const safeSheetName = `${sheetName || "Sheet"}`.replace(/[<>:"/\\|?*\x00-\x1F]/g, "_").trim() || "Sheet";
    return transformedFileName.replace(/(\.[^.]+)$/, `-${safeSheetName}$1`);
}

function isSheetJsWorksheet(sheet) {
    return sheet !== null && typeof sheet === "object" && !Array.isArray(sheet);
}

async function downloadSheetWorkbooksDirectly(sheetDetails, documentFileName) {
    const seenPaths = new Set();
    for (const sheetDetail of sheetDetails || []) {
        if (!sheetDetail?.docPath || seenPaths.has(sheetDetail.docPath)) {
            continue;
        }
        seenPaths.add(sheetDetail.docPath);
        await downloadS3Object(
            sheetDetail.docPath,
            getSheetDownloadFileName(documentFileName, sheetDetail.inputSheetName)
        );
    }
}

export async function downloadOutputFile(allSheetDetails, documentFileName, headersInfo, xlType, removeTransformedSheets, consolidatedSheetName) {
    const directDownloadFileName = getTransformedDownloadFileName(documentFileName);
    const downloadableSheetDetails = allSheetDetails?.filter(sheetDetail => sheetDetail?.docPath) || [];
    const singleSheetDetail = downloadableSheetDetails.length === 1 ? downloadableSheetDetails[0] : undefined;
    const hasHeaderDetails =
        headersInfo?.includeHeaders === true &&
        headersInfo?.tempArrayBuffer !== null &&
        headersInfo?.sheetIndex !== -1;
    const canPrepareSingleSheetDownload =
        ["SOV", "Loss Run"].includes(xlType) &&
        singleSheetDetail?.docPath &&
        singleSheetDetail?.inputSheetName;
    if (canPrepareSingleSheetDownload) {
        let preparedDownload;
        try {
            preparedDownload = await prepareSingleSheetDownload(singleSheetDetail, xlType, removeTransformedSheets);
        } catch (error) {
            console.warn("Unable to prepare single-sheet workbook for download; using the existing download path", error);
        }
        if (preparedDownload?.eligible === true) {
            const transformedFileName = documentFileName.endsWith(".xls")
                ? documentFileName.replace(/(\.[^.]+)$/, "-Transformed$1.xlsx").replace(".xls", "")
                : documentFileName.replace(/(\.[^.]+)$/, "-Transformed$1");
            if (!hasHeaderDetails) {
                await downloadS3Object(preparedDownload.xlsxFilePath, transformedFileName);
                return;
            }
            allSheetDetails = allSheetDetails.map(sheetDetail =>
                sheetDetail === singleSheetDetail
                    ? { ...sheetDetail, docPath: preparedDownload.xlsxFilePath }
                    : sheetDetail
            );
        }
    }

    const newWorkbook = XLSX.utils.book_new();
    for (let i = 0; i < allSheetDetails?.length; i++) {
        let sheetDetail = allSheetDetails[i];
        const arrayBuffer = await fetchExcelFromS3(sheetDetail.docPath);
        if (arrayBuffer) {
            const workbook = XLSX.read(arrayBuffer, { type: 'array', cellNF: true });
            let jsonSheetName = sheetDetail.inputSheetName;
            let combinedSheetName;
            if (consolidatedSheetName !== undefined && consolidatedSheetName !== "") {
                combinedSheetName = xlType === "SOV" ? consolidatedSheetName : consolidatedSheetName;
            }
            let matchedSheetIndex;
            if (jsonSheetName === "Combined Sheet") {
                matchedSheetIndex = workbook.SheetNames.findIndex(j => j.toLowerCase() === combinedSheetName?.toLowerCase() || j === "Combined Sheet");
            } else {
                matchedSheetIndex = workbook.SheetNames.findIndex(j =>
                    removeWordAFterLastHypen(j).trim().toLowerCase() === jsonSheetName.trim().toLowerCase()
                    || j.trim().toLowerCase() === consolidatedSheetName.trim().toLowerCase()
                );
            }
            let sheetName = matchedSheetIndex !== -1 ? workbook.SheetNames[matchedSheetIndex] : workbook.SheetNames[0];

            if (sheetName) {

                let originalSheet = workbook.Sheets[sheetName];
                if (!isSheetJsWorksheet(originalSheet)) {
                    if ((allSheetDetails || []).length === 1 && sheetDetail.docPath) {
                        await downloadS3Object(sheetDetail.docPath, directDownloadFileName);
                        return;
                    }
                    if (!hasHeaderDetails && ["SOV", "Loss Run"].includes(xlType)) {
                        console.warn("Downloading transformed workbooks directly because at least one sheet is not materialized", {
                            docPath: sheetDetail.docPath,
                            sheetName,
                            sheetType: typeof originalSheet
                        });
                        await downloadSheetWorkbooksDirectly(downloadableSheetDetails, documentFileName);
                        return;
                    }
                    console.warn("Skipping transformed sheet download because worksheet is not materialized", {
                        docPath: sheetDetail.docPath,
                        sheetName,
                        sheetType: typeof originalSheet
                    });
                    continue;
                }
                let updatedSheet = {};
                if (headersInfo?.tempArrayBuffer !== null && headersInfo?.sheetIndex !== -1 && headersInfo?.includeHeaders) {
                    const tempWorkbook = XLSX.read(headersInfo?.tempArrayBuffer, { type: 'array', cellNF: true });
                    const tempHeaderSheet = tempWorkbook.Sheets[tempWorkbook.SheetNames[headersInfo.sheetIndex]];
                    const headerInfoRange = XLSX.utils.decode_range(tempHeaderSheet['!ref']);
                    const originalRange = XLSX.utils.decode_range(originalSheet['!ref']);
                    const rowOffset = headerInfoRange.e.r + 2;

                    const copyCells = (sourceSheet, targetSheet, range, offset) => {
                        for (let R = range.s.r; R <= range.e.r; ++R) {
                            for (let C = range.s.c; C <= range.e.c; ++C) {
                                const cellRef = XLSX.utils.encode_cell({ r: R + offset, c: C });
                                targetSheet[cellRef] = { ...sourceSheet[XLSX.utils.encode_cell({ r: R, c: C })] };
                            }
                        }
                    };
                    copyCells(tempHeaderSheet, updatedSheet, headerInfoRange, 0);
                    copyCells(originalSheet, updatedSheet, originalRange, rowOffset);

                    updatedSheet['!ref'] = XLSX.utils.encode_range({
                        s: { r: 0, c: 0 },
                        e: { r: originalRange.e.r + rowOffset, c: Math.max(originalRange.e.c, headerInfoRange.e.c) }
                    });
                }

                const downloadSheetName = buildDownloadSheetName(sheetName, newWorkbook.SheetNames);
                const isSheetExists = newWorkbook.SheetNames.some(existingSheetName =>
                    existingSheetName.trim().toLowerCase() === downloadSheetName.trim().toLowerCase()
                );

                if (!isSheetExists) {
                    const sheetToAppend = Object.entries(updatedSheet).length !== 0 ? updatedSheet : originalSheet;
                    XLSX.utils.book_append_sheet(newWorkbook, sheetToAppend, downloadSheetName);
                }
            }
        }
    }

    if (newWorkbook.SheetNames.length === 0 && allSheetDetails?.[0]?.docPath) {
        await downloadS3Object(allSheetDetails[0].docPath, directDownloadFileName);
        return;
    }
    XLSX.writeFile(newWorkbook, directDownloadFileName, { compression: true });
}

export async function translateSOVHeaders(headers, document, documentObj) {
    const user = await Auth.currentAuthenticatedUser({ bypassCache: true });
    const data = await invokeLambdaWithRetry("instanceHandler", {
        body: { target: "translateSOVHeaders", headers, ...(document?.archivedQa ? { document } : {}), access_token: user.signInUserSession.idToken.jwtToken }
    });
    if (data?.statusCode !== 200 || data?.response?.error) throw new Error("Unable to translate headers. Please try again.");
    return data.response;
}

export async function loadMapper(inputHeaderRowNum, childInputHeaderRowNum, storeSheetName, document, documentObj) {
    try {
        const user = await Auth.currentAuthenticatedUser({
            bypassCache: true  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
        });
        const body = {
            "target": "fetch-mapper-metadata",
            "document": document,
            "control": {
                headerRowIndex: inputHeaderRowNum,
                inputSheetName: storeSheetName,
                childHeaderRowIndex: childInputHeaderRowNum && childInputHeaderRowNum !== inputHeaderRowNum ? parseInt(childInputHeaderRowNum) : undefined
            },
            "access_token": user.signInUserSession.idToken.jwtToken,
        };
        const init = {
            body: body
        };
        const data = await invokeLambdaWithRetry("instanceHandler", init);
        return data?.response;
    } catch (err) {
        console.error('err: ', err);
        return false;
    }
}

export async function fetchInvokeType(target) {
    const instanceLambdaTargetRoutes = await getParameterData(
        "INSTANCE_LAMBDA_TARGET_ROUTES"
    );
    let invokeTypeForTarget = "lambda"; // default
    invokeTypeForTarget = instanceLambdaTargetRoutes?.default_invocation?.trim()?.toLowerCase() === "api" ? "api" : "lambda";
    let routeConfig;
    if (instanceLambdaTargetRoutes) {
        routeConfig = instanceLambdaTargetRoutes[target];
        if (routeConfig) {
            invokeTypeForTarget = instanceLambdaTargetRoutes?.default_invocation ? instanceLambdaTargetRoutes?.default_invocation.trim()?.toLowerCase() : routeConfig?.invoke?.trim()?.toLowerCase() ?? "lambda";
        }
    }
    return invokeTypeForTarget;
}

export async function fetchMappedData(updatedKeyValues, childInputHeaderRowNum, inputHeaderRowNum, storeSheetName, document, documentObj, runMacro, autoFinishCall, overWriteFormulas, sheetName, action, platform, isResetMapping, shouldStopPolling, options = {}) {
    try {
        const user = await Auth.currentAuthenticatedUser({
            bypassCache: true  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
        });
        let body = {
            "target": "fetch-mapped-data",
            "document": document,
            "control": {
                headerRowIndex: parseInt(inputHeaderRowNum),
                inputSheetName: storeSheetName,
                totalConfidenceColumns: 0,
                childHeaderRowIndex: childInputHeaderRowNum && childInputHeaderRowNum !== inputHeaderRowNum ? parseInt(childInputHeaderRowNum) : undefined,
                overWriteFormulas: overWriteFormulas,
                action: action
            },
            "platform": platform,
            "isResetMapping": isResetMapping,
            "access_token": user.signInUserSession.idToken.jwtToken,
        };
        if (updatedKeyValues !== undefined) {
            body.control.keyValues = updatedKeyValues;
        }
        if (sheetName !== "") {
            body.control.consolidateSheet = sheetName;
        }
        const qaMacroKeys = options.qaMacroKeys ?? options.geographicMacroKeys;
        if (qaMacroKeys?.length) {
            body.control.qaMacroKeys = qaMacroKeys;
        }
        const init = {
            body: body
        };
        body.asyncResponse = true;
        const requestStartedAt = Date.now();
        const data = await invokeLambdaWithRetry("instanceHandler", init);
        const invokeTypeForTarget = await fetchInvokeType(body?.target);
        let response;
        const actionLabel = resolveMappedDataAsyncActionLabel(action, runMacro);
        const macroProcessingLabel = platform ? "Post processing" : "Macro processing";
        const asyncEventBase = {
            submissionIdentifier: document.submissionIdentifier,
            documentId: document.document_id,
            event: "fetch-mapped-data",
            sheetName: storeSheetName,
            isRunMacro: runMacro === true,
            isMappedDataAsync: true,
            mappedDataAction: action
        };
        const shouldPollForStatus =
            invokeTypeForTarget?.toLowerCase() === "api" ||
            data?.response?.statusCode === 202 ||
            data?.response?.apiStatus?.toString()?.trim()?.toLowerCase() === "pending";
        let shouldEmitAsyncProgress = runMacro === true;
        if (shouldPollForStatus) {
            if (runMacro) {
                emitAsyncProgress({
                    ...asyncEventBase,
                    phase: "queued",
                    message: platform ? "Post processing is being queued" : "Macro job is being queued",
                    percent: 0
                });
            }
            const apiStatusJson = await fetchApiStatusJSON(document.submissionIdentifier, document.document_id, "fetch-mapped-data", storeSheetName);
            shouldEmitAsyncProgress = shouldEmitAsyncProgress || hasOrchestratedMappedDataProgress(apiStatusJson);
            let apiStatus = apiStatusJson?.apiStatus?.toString()?.trim()?.toLowerCase();
            const statusUpdatedAt = apiStatusJson?.progress?.updatedAt ? Date.parse(apiStatusJson.progress.updatedAt) : NaN;
            const isFreshCompletedStatus = apiStatus === "completed" && Number.isFinite(statusUpdatedAt) && statusUpdatedAt >= (requestStartedAt - 1000);
            const progressUpdatedAt = apiStatusJson?.progress?.updatedAt ? Date.parse(apiStatusJson.progress.updatedAt) : NaN;
            const isFreshProgressStatus =
                Number.isFinite(progressUpdatedAt) &&
                progressUpdatedAt >= (requestStartedAt - 1000);
            const shouldEmitInitialProgress =
                apiStatusJson?.progress &&
                isFreshProgressStatus &&
                (
                    !apiStatus
                    || apiStatus === "pending"
                    || apiStatus === "queued"
                    || apiStatus === "running"
                    || apiStatus === "retrying"
                    || isFreshCompletedStatus
                );

            if (shouldEmitInitialProgress && shouldEmitAsyncProgress) {
                emitAsyncProgress(buildAsyncProgressPayload({
                    ...asyncEventBase,
                    ...apiStatusJson.progress
                }, apiStatusJson));
            }

            if (!apiStatus || ["pending", "queued", "running", "retrying"].includes(apiStatus)
                || (["completed", "failed", "timed out", "timeout"].includes(apiStatus) && !isFreshProgressStatus)) {
                const apiData = await pollApiStatus(document.templateName, document.submissionIdentifier, document.document_id, "fetch-mapped-data", storeSheetName, shouldStopPolling, requestStartedAt);
                if (apiData.status === "completed") {
                    response = apiData?.response?.response;
                } else if (apiData.status === "stopped") {
                    return { pollingStopped: true };
                } else if (apiData.status === "failed" || apiData.status === "timed out" || apiData.status === "timeout") {
                    const isTimeoutStatus = apiData.status === "timed out" || apiData.status === "timeout";
                    const failureMessage = getAsyncErrorMessage(apiData.response, runMacro ? `${macroProcessingLabel} failed before completion.` : `${actionLabel} failed before completion.`);
                    if (shouldEmitAsyncProgress) {
                        emitAsyncProgress({
                            ...asyncEventBase,
                            apiStatus: isTimeoutStatus ? "Timed out" : "Failed",
                            phase: isTimeoutStatus ? "timeout" : "failed",
                            message: failureMessage,
                            completed: 0,
                            total: 1,
                            percent: 100,
                            status: apiData.status
                        });
                    }
                    throw new Error(failureMessage);
                }
            } else if (apiStatus === "completed") {
                response = apiStatusJson?.response?.response ?? apiStatusJson?.response;
            } else if (apiStatus === "failed" || apiStatus === "timed out" || apiStatus === "timeout") {
                const isTimeoutStatus = apiStatus === "timed out" || apiStatus === "timeout";
                const failureMessage = getAsyncErrorMessage(apiStatusJson?.response, runMacro ? `${macroProcessingLabel} failed before completion.` : `${actionLabel} failed before completion.`);
                if (shouldEmitAsyncProgress) {
                    emitAsyncProgress({
                        ...asyncEventBase,
                        apiStatus: isTimeoutStatus ? "Timed out" : "Failed",
                        phase: isTimeoutStatus ? "timeout" : "failed",
                        message: failureMessage,
                        completed: 0,
                        total: 1,
                        percent: 100,
                        status: apiStatus
                    });
                }
                throw new Error(failureMessage);
            }
        } else {
            response = data?.response;
        }
        if (response) {
            if (!response.jsonFilePath || response.error) return false;
            const jsonData = options.metadataOnly === true
                ? { jsonFilePath: response.jsonFilePath }
                : await fetchJSONFromS3(response.jsonFilePath);
            if (shouldPollForStatus && shouldEmitAsyncProgress) {
                emitAsyncProgress(buildAsyncProgressPayload({
                    ...asyncEventBase,
                    apiStatus: "Completed",
                    phase: "completed",
                    message: runMacro ? `${macroProcessingLabel} completed` : `${actionLabel} completed`,
                    completed: 1,
                    total: 1,
                    percent: 100
                }, { apiStatus: "Completed", isRunMacro: runMacro === true, isMappedDataAsync: true, mappedDataAction: action }));
            }
            return jsonData;
        } else {
            return false;
        }
    } catch (err) {
        console.error('err: ', err);
        return false;
    }
}

export async function fetchTransformedJSON(document, storeSheetName, documentObj, sheetName, options = {}) {
    try {
        const user = await Auth.currentAuthenticatedUser({
            bypassCache: true  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
        });
        let body = {
            "target": "fetch-transformed-data",
            "document": document,
            "access_token": user.signInUserSession.idToken.jwtToken,
            "sheetName": storeSheetName
        };
        if (sheetName !== "") {
            body.consolidateSheet = sheetName;
        }
        const init = {
            body: body
        };
        const data = await invokeLambdaWithRetry("instanceHandler", init);
        const response = data?.response;
        if (response && response.error !== undefined) {
            return response;
        } else if (response && response.transformedJsonFilePath !== undefined) {
            if (options.metadataOnly === true) {
                return response;
            }
            const transformedJsonBytes = Number(response.transformedJsonBytes || 0);
            const transformedRows = Number(response.transformedRows || 0);
            const windowMinBytes = Number(options.windowMinBytes || 50 * 1024 * 1024);
            const windowMinRows = Number(options.windowMinRows || 50000);
            const shouldUseWindow =
                options.windowed === true
                || response?.transformedPreviewSource === "workbook"
                || transformedJsonBytes >= windowMinBytes
                || transformedRows >= windowMinRows;
            if (shouldUseWindow) {
                const preview = await fetchLargeGridPreviewWindow({
                    jsonPath: response.transformedJsonFilePath,
                    metaData: {
                        ...(options.metaData || {}),
                        postProcessingMode: options.postProcessingMode || options.metaData?.postProcessingMode || "scalable"
                    },
                    side: "output",
                    rowStart: Number(options.rowStart || 1),
                    rowCount: Number(options.rowCount || 5000),
                    forcePreview: true
                });
                if (preview?.success && preview.data) {
                    return {
                        ...preview.data,
                        transformedJsonFilePath: response.transformedJsonFilePath,
                        transformedJsonBytes,
                        transformedRows,
                        transformedWorkbookPath: response.transformedWorkbookPath,
                        largeGridPreview: preview.info
                    };
                }
                return {
                    error: "Large transformed data could not be opened in preview-window mode. Please retry after the document finishes processing."
                };
            }
            let jsonData = await fetchJSONFromS3(response.transformedJsonFilePath, documentObj?.InstanceRegion, documentObj?.InstanceBucket);
            return {
                ...jsonData,
                transformedJsonFilePath: response.transformedJsonFilePath,
                transformedJsonBytes,
                transformedRows,
                transformedWorkbookPath: response.transformedWorkbookPath
            };
        } else {
            return false;
        }
    } catch (err) {
        console.error('err: ', err);
        return false;
    }
}

export async function uploadFileToSharePoint() {
    return false;
}

export async function generateOutputArrayBuffer() {
    return false;
}

export async function uploadAllTransformedSheetsToS3() {
    return false;
}

export async function fetchMergedHeaders(parentHeaderRowIdx, childHeaderRowIdx, sheetName, document, documentObj) {
    try {
        const user = await Auth.currentAuthenticatedUser({
            bypassCache: true  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
        });
        const body = {
            "target": "fetch-merged-headers",
            "document": document,
            "filePath": document?.extractedPdfExcelPath === undefined ? document.documentFullPath : document?.extractedPdfExcelPath,
            "control": {
                filePath: document?.extractedPdfExcelPath === undefined ? document.documentFullPath : document?.extractedPdfExcelPath,
                sheetName,
                parentHeaderRowIdx,
                childHeaderRowIdx
            },
            "access_token": user.signInUserSession.idToken.jwtToken,
        };
        const init = {
            body: body
        };
        const data = await invokeLambdaWithRetry("instanceHandler", init);
        let response = data?.response;
        if (response) {
            const jsonData = await fetchJSONFromS3(response.inputSheetJSONFilePath);
            return jsonData;
        } else {
            return false;
        }
    } catch (err) {
        console.error('err: ', err);
        return false;
    }
}
export async function invokeOcrService() {
    return false;
}

// Compatibility bridge for the shared extraction tool. Ask Ora workbook
// mapping is intentionally exposed only by the GlobalOps host.
export async function listAskOraWorkbookPrompts() {
    return { prompts: [] };
}

export async function saveAskOraWorkbookPrompt() {
    throw new Error("Ask Ora workbook mapping is available from GlobalOps only.");
}

export async function deleteAskOraWorkbookPrompt() {
    throw new Error("Ask Ora workbook mapping is available from GlobalOps only.");
}

export async function runAskOraWorkbookMapping() {
    throw new Error("Ask Ora workbook mapping is available from GlobalOps only.");
}

export async function fetchAllSheetsTransformedJSON(document, sheetName) {
    try {
        const user = await Auth.currentAuthenticatedUser({
            bypassCache: true  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
        });
        const body = {
            "target": "fetch-allsheets-transformed-json",
            "document": document,
            "access_token": user.signInUserSession.idToken.jwtToken,
        };
        if (sheetName !== "") {
            body.consolidateSheet = sheetName;
        }
        const init = {
            body: body
        };
        const data = await invokeLambdaWithRetry("instanceHandler", init);
        const response = data?.response;
        if (response) {
            let jsonData = await fetchJSONFromS3(response.transformedJsonFilePath);
            return jsonData;
        } else {
            return false;
        }
    } catch (err) {
        console.error('err: ', err);
        return false;
    }
}

export async function prepareSingleSheetDownload(source, inputFileType, removeTransformedSheets) {
    const user = await Auth.currentAuthenticatedUser({
        bypassCache: true
    });
    const init = {
        body: {
            target: "prepare-single-sheet-download",
            source: {
                transformationFilePath: source.docPath,
                inputSheetName: source.inputSheetName,
                transformedSheetName: source.transformedSheetName,
                templateName: source.templateName
            },
            templateName: source.templateName,
            inputFileType,
            removeTransformedSheets,
            access_token: user.signInUserSession.idToken.jwtToken
        }
    };
    const data = await invokeLambdaWithRetry("instanceHandlerLarge", init, undefined, undefined, true);
    return data?.response || { eligible: false };
}

export async function generateFinalTransformedWorkbook(document, options = {}) {
    if (document?.archivedQa) return requestArchivedSovDownload(document, options, { authenticate: options => Auth.currentAuthenticatedUser(options), invoke: invokeLambdaWithRetry, requestId: uuid });
    const user = await Auth.currentAuthenticatedUser({
        bypassCache: true
    });
    const init = {
        body: {
            target: "generate-final-transformed-workbook",
            document,
            inputFileType: options.inputFileType,
            removeTransformedSheets: options.removeTransformedSheets,
            consolidatedSheetName: options.consolidatedSheetName,
            summarySheetName: options.summarySheetName,
            documentFileName: options.documentFileName,
            headersInfo: options.headersInfo,
            access_token: user.signInUserSession.idToken.jwtToken
        }
    };
    const data = await invokeLambdaWithRetry("instanceHandlerLarge", init, undefined, undefined, true);
    return data?.response || { eligible: false };
}

export async function downloadFinalTransformedWorkbook(document, documentFileName, options = {}) {
    const finalWorkbook = await generateFinalTransformedWorkbook(document, {
        ...options,
        documentFileName
    });
    if (finalWorkbook?.eligible === true && finalWorkbook?.path) {
        await downloadS3Object(finalWorkbook.path, finalWorkbook.fileName || getTransformedDownloadFileName(documentFileName));
        return finalWorkbook;
    }
    return false;
}

export async function fetchCurrencyData(instanceDetails) {
    return false;
}

export function combineSheetsData(instanceDetails) {
    return false;
}

export function getTextFromImageUsingTrcOcr(instanceDetails) {
    return false;
}

export async function generateArrayBuffer() {
    return false;
}

export async function generateMarkCompleteOutputArrayBuffer() {
    return false;
}

export async function syncFileFromSharepoint() {
    return false;
}

export async function checkTransformedFile() {
    return false;
}

export async function getTemplateRules(templateName) {
    // Documents without a template (attachments, cover pages) would request undefined_rules.json.
    // The 404 already fell back to the default rules, so ask for them directly.
    if (!templateName || templateName === "undefined") templateName = "default";
    if (rulesCache[templateName]) {
        return rulesCache[templateName];
    }

    try {
        let templateColumnRules = await fetchJSONFromS3(
            `templates/rules/${templateName}_rules.json`
        );
        if (templateColumnRules === false) {
            console.warn("rules.json not found, applying default values...");
            const defaultKey = "default_rules";
            if (rulesCache[defaultKey]) {
                return rulesCache[defaultKey];
            }
            const defaultRules = await fetchJSONFromS3(`templates/rules/default_rules.json`);
            if (defaultRules === false) {
                console.error("Default rules.json also not found.");
                return {}; // fallback to empty
            }
            rulesCache[defaultKey] = defaultRules;
            return defaultRules;
        }
        rulesCache[templateName] = templateColumnRules;
        return templateColumnRules;
    } catch (error) {
        console.error("Error reading rules file: ", error);
        return {};
    }
}

export async function convertExcelToJson(byteArray) {
    const workbook = XLSX.read(byteArray);
    const jsonData = [];
    workbook.SheetNames.forEach((sheetName) => {
        const sheet = workbook.Sheets[sheetName];
        const sheetJson = [];
        if (!sheet['!ref']) {
            jsonData.push([]);
            return;
        }
        const range = XLSX.utils.decode_range(sheet['!ref']);

        for (let row = range.s.r; row <= range.e.r; row++) {
            const rowData = [];

            for (let col = range.s.c; col <= range.e.c; col++) {
                const cellRef = XLSX.utils.encode_cell({ r: row, c: col });
                const cellValue = sheet[cellRef] ? sheet[cellRef].v : null;
                if (cellValue !== null && cellValue !== "") {
                    rowData.push({ value: cellValue });
                } else {
                    rowData.push({ value: "" });
                }
            }

            // Only push the row if there's at least one non-empty value
            if (rowData.some(cell => cell.value !== "")) {
                sheetJson.push(rowData);
            }
        }
        jsonData.push(sheetJson);
    });
    return jsonData;
}

export async function getTrfFile(jsonExtractpath, jsonExtractOriginalpath, submissionIdentifier, document_id) {
    try {
        const user = await Auth.currentAuthenticatedUser({
            bypassCache: true, // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
        });
        const body = {
            target: "processDocument",
            access_token: user.signInUserSession.idToken.jwtToken,
            option: "get-trf",
            jsonExtractpath: jsonExtractpath,
            jsonExtractOriginalpath: jsonExtractOriginalpath,
            submissionIdentifier: submissionIdentifier,
            document_id: document_id,
        };
        const init = {
            body: JSON.stringify(body),
        };
        const resp = await invokeLambdaWithRetry("instanceHandler", init);
        return resp;
    } catch (err) {
        console.error("err: ", err);
        return false;
    }
}

export async function convertPdfToExcel() {
    return false;
}

export const generateSummaryTable = async () => {
    return false;
}

export const getColumnIndexes = (headerRow, keyword) => {
    let headerIndexes = headerRow.reduce((indexes, el, i) => {
        const value = el?.value?.toString().toLowerCase().trim();
        if (value && value.startsWith(keyword.toLowerCase()))
            indexes.push({ index: i, col: el.value });
        return indexes;
    }, []);
    return headerIndexes;
}

export const processOpValUnmatchedEntities = async (endorsementDependentEntities, origSheetJson) => {
    let endorsementEntityList = [...endorsementDependentEntities];
    // Find the column index of "entity name"
    let entityNameIndex = endorsementEntityList[0].findIndex((i) =>
        i.value?.toString().toLowerCase()?.trim() === "entity name"
    );
    endorsementEntityList.shift(); // Remove the header row from endorsementEntityList

    let jsonData = JSON.parse(JSON.stringify(origSheetJson[0])); // deep copy
    const headerRow = jsonData.shift(); //Remove the header row from original sheet data
    // Get the indexes of columns starting with specific keywords
    const outputColIndexes = getColumnIndexes(headerRow, "output ");
    const pageNumberIndexes = getColumnIndexes(headerRow, "page number");
    const coordinatesIndexes = getColumnIndexes(headerRow, "coordinates");
    const srcFilePageNumIndexes = getColumnIndexes(headerRow, "src file pg number");
    const srcFileNameIndexes = getColumnIndexes(headerRow, "src file name");
    const fileNameIndexes = getColumnIndexes(headerRow, "file name");
    let teamMemberColIndex = headerRow.findIndex((i) => i.value?.toString().toLowerCase()?.trim() === "team member");
    // Combined all index groups into a single array
    const indexGroups = [
        outputColIndexes,
        pageNumberIndexes,
        coordinatesIndexes,
        srcFilePageNumIndexes,
        srcFileNameIndexes,
        fileNameIndexes,
    ];
    // Iterate through each data row in the sheet
    jsonData?.forEach(row => {
        const entityName = row[entityNameIndex]?.value?.trim();
        // Check if the current entity name exists in the endorsementEntityList
        let isCheckEntityExist = endorsementEntityList.some(
            item => item[entityNameIndex].value?.trim() === entityName
        );
        if (!isCheckEntityExist) {  // If is not endorsement dependent entity, clear relevant column values
            indexGroups.forEach((group) => {
                group?.forEach(({ index }) => {
                    if (row[index]) row[index].value = "";
                });
            });
            if (row[teamMemberColIndex]) {
                row[teamMemberColIndex].value = "";
            }
        }
    });

    origSheetJson[0] = [headerRow, ...jsonData]; // Reconstruct origSheetJson[0] by adding header back
    return origSheetJson;
}

export async function fetchGrossAreaData(instanceDetails) {
    return false;
}

export async function fetchCargoLocationData(instanceDetails) {
    return false;
}

export const findSimilarMatchValue = async (instanceDetails, selectedText, dropdownOptions) => {
    try {
        const user = await Auth.currentAuthenticatedUser({
            bypassCache: true  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
        });
        const body = {
            "access_token": user.signInUserSession.idToken.jwtToken,
            "target": "extract-text-fuzzy-match",
            "document": instanceDetails,
            "extractedText": selectedText,
            "dropdownOptions": dropdownOptions
        };
        const init = {
            body: body
        };
        const data = await invokeLambdaWithRetry("instanceHandler", init);
        return data.response;
    } catch (err) {
        console.error('err: ', err);
        return false;
    }
}

export const fetchRotationStates = async (instanceDetails) => {
    try {
        let filePath = `${instanceDetails?.submissionIdentifier}/rotationStates.json`;
        let response = await fetchFromS3(filePath);
        const jsonData = await (await storageResultToBlob(response)).text();
        return JSON.parse(jsonData);
    } catch (e) {
        // If file doesn't exist, return empty object
        return {};
    }
}

export const fetchApiStatusJSON = async (submissionIdentifier, documentId, target, sheetName) => {
    try {
        let apiStatusFilePath = `${submissionIdentifier}/api_status.json`;
        let apiStatusJson = await fetchJSONFromS3(apiStatusFilePath);
        const apiCallKey = `${target}${documentId ? "_" + documentId : ""}${sheetName ? "_" + sheetName : ""}`;
        let specificeventAPIStatus = apiStatusJson[apiCallKey];
        return specificeventAPIStatus;
    } catch (e) {
        return {};
    }
}

export const pollApiStatus = async (templateName, submissionIdentifier, documentId, event, sheetName, shouldStopPolling, minUpdatedAtMs) => {
    const templateRules = await fetchJSONFromS3(`templates/rules/${templateName}_rules.json`);
    let apiPollingInterval = templateRules?.metaData?.apiPollingInterval;
    if (apiPollingInterval === undefined) {
        const defaultRules = await fetchJSONFromS3(`templates/rules/default_rules.json`).catch(() => ({}));
        apiPollingInterval = defaultRules?.metaData?.apiPollingInterval;
    }
    apiPollingInterval = Number(apiPollingInterval) || 5;
    return new Promise((resolve) => {
        const intervalId = setInterval(async () => {
            if (shouldStopPolling?.()) {
                clearInterval(intervalId);
                resolve({ status: "stopped" });
                return;
            }
            try {
                const apiStatusJson = await fetchApiStatusJSON(submissionIdentifier, documentId, event, sheetName);
                if (shouldStopPolling?.()) {
                    clearInterval(intervalId);
                    resolve({ status: "stopped" });
                    return;
                }
                const statusUpdatedAt = apiStatusJson?.progress?.updatedAt ? Date.parse(apiStatusJson.progress.updatedAt) : NaN;
                const isStaleStatus =
                    Number.isFinite(minUpdatedAtMs)
                    && (!Number.isFinite(statusUpdatedAt) || statusUpdatedAt < (minUpdatedAtMs - 1000));
                const status = apiStatusJson?.apiStatus?.trim()?.toLowerCase();
                if (isStaleStatus) {
                    return;
                }
                if (apiStatusJson?.progress) {
                    emitAsyncProgress(buildAsyncProgressPayload({
                        submissionIdentifier,
                        documentId,
                        event,
                        sheetName,
                        ...apiStatusJson.progress
                    }, apiStatusJson));
                }
                if (!status) {
                    return;
                }
                if (!["pending", "queued", "running", "retrying"].includes(status)) {
                    if (status === "completed" && apiStatusJson?.response === undefined) {
                        return;
                    }
                    clearInterval(intervalId);
                    resolve({ status, response: apiStatusJson.response });
                }
            } catch {
                // Continue polling through transient S3/network reads. Only explicit terminal
                // api_status values should end an async mapped-data macro run.
            }
        }, apiPollingInterval * 1000);
    });
};

export const updatedSummarySheet = async () => {
    return false;
}

export async function generateSummaryDataForSov(submissionIdentifier, templateName, document_id, templateVersionNumber) {
    try {
        const user = await Auth.currentAuthenticatedUser({
            bypassCache: true, // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
        });
        const body = {
            access_token: user.signInUserSession.idToken.jwtToken,
            target: "generateSummaryDataForSov",
            submissionIdentifier: submissionIdentifier,
            templateName: templateName,
            templateVersionNumber: templateVersionNumber,
            document_id: document_id
        };
        const init = {
            body: body,
        };
        const data = await invokeLambdaWithRetry("instanceHandler", init);
        return data.response;
    } catch (err) {
        console.info(err);
        return false;
    }
}

export async function fetchALLExcelSheetData(instanceExcelDetails, checkSheetName, options = {}) {
    let buffer = await fetchExcelFromS3(
        instanceExcelDetails.docPath,
        instanceExcelDetails.instanceRegion,
        instanceExcelDetails.instanceBucket
    );
    const maxRows = Number.isFinite(Number(options?.maxRows)) && Number(options.maxRows) > 0
        ? Math.floor(Number(options.maxRows))
        : undefined;
    const workbook = XLSX.read(buffer, {
        type: "array",
        ...(maxRows ? { sheetRows: maxRows + 1 } : {})
    });
    const worksheet = workbook.Sheets[checkSheetName];
    if (!worksheet) return [[]];
    const jsonData = XLSX.utils.sheet_to_json(worksheet, {
        defval: ""
    });
    if (!jsonData.length) return [[]];
    const headers = Object.keys(jsonData[0]);
    const headerRow = headers.map(h => ({ value: h }));
    const dataRows = jsonData.map(row => headers.map(header => ({ value: row[header] ?? "" })));
    return [[headerRow, ...dataRows]];
}
